import { excludeData } from '@root-gipro/modules/filter/utils/exclude-data'
import { showNotify } from '@root-gipro/modules/notify/store/actions'
import { UserProjectsType } from '@root-gipro/modules/userProjects/models/interfaces/user-project.actions'
import {
	IAllRequestProject,
	ICheckedErrors,
	ICheckedMassErrors,
	IRequestProject,
	IT7Data,
	IUnc,
	IUncAddBuffer,
	IUncCell,
	IUnnormalizedListItem,
	IUserProject,
} from '@root-gipro/modules/userProjects/models/interfaces/user-projects.model'
import {
  checkMassErrorLoad,
  fetchUncs as fetchUncsForUpdate,
  loadingAddUnc,
  savedUserProjectTrigger,
  setActiveUncs,
  setAnalogUncList,
  setAssistStatus,
  setCopyAlert,
  setDataImportMagazine, 
  setDeletedProjectRPC,
  setLoadingStates,
  setLoadProjectSolutions,
  setOpenModalImportMagazine,
  setProgressPrecent, 
  setProjectAddModalOA, 
  setProjectDeleteModalOA, 
  setProjectRPC,
  setProjectTechSolutions,
  setUncCells,
  setUncFullInfo,
  setUserProjects, 
  updateProjectRPC
} from '@root-gipro/modules/userProjects/store/actions'

import { AdminPanelType } from '@root-gipro/modules/AdminPanel/interfaces/admin-panel.actions'
import { showFilterResult } from '@root-gipro/modules/filter/store/actions'
import store from '@root-gipro/store'
import { setFetchFailure } from '@root-gipro/store/actions'
import { authorizeApi, fetchData, fetchHeaders, refreshToken, userProjectsApi } from '@root-gipro/store/api'
import { IUncMain } from '@root-gipro/store/interfaces'
import produce from 'immer'
import { nanoid } from 'nanoid'
import QueryString from 'qs'
import { ReactText } from 'react'
import { push } from 'react-router-redux'
import { call, cancel, debounce, delay, fork, put, takeEvery, takeLatest } from 'redux-saga/effects'
import {
	addUserProjects,
	loadingT7Data,
	loadingUserProjects,
	setAllowMoreUserProjects,
	setExportable,
	setMassErrors,
	setUserProjectInList,
	setUserProjectsPaginationCount,
} from './actions'
import { onAccessTokenFetched } from '../utils/helpers'
import { fetchWith401Retry } from '@root-gipro/helpers/fetchWith401Retry'

const limit = 5

//Сага загрузки/обновления проекта
function* fetchUserProject(action: { type: typeof UserProjectsType.FETCH_USER_PROJECT; id: string }) {
	yield put(setFetchFailure(false))
	const projectFetch: IUserProject = yield call(fetchData, `/user-projects/${action.id}`, (res: any) => res.userProject)
	if (projectFetch) {
		const project = { ...projectFetch, locked: !!projectFetch.locked }
		// временно оставил до теста
		// const clone = Object.assign({}, project)
		// delete clone.id
		// delete clone.userId
		// delete clone.author

		yield put({ type: UserProjectsType.CHOOSE_PROJECT, project })
		yield put({ type: UserProjectsType.SET_ORIGINAL_OBJ, project })

		// yield put(saveUserProjectAction(clone, false, project.id, false))
	} else {
		yield put(setFetchFailure(true))
	}
}

function* updateProgressDuringRequest(expectedTime: number) {
	let progress = 0
	const timeStepFast = expectedTime / 80
	const timeStepSlow = (expectedTime / 80) * 2

	try {
		while (progress < 70) {
			yield delay(timeStepFast * 1000)
			progress += 1
			yield put(setProgressPrecent(progress))
		}

		while (progress < 95) {
			yield delay(timeStepSlow * 1000)
			progress += 1
			yield put(setProgressPrecent(progress))
		}

		yield delay(Infinity)
	} catch {
		yield put(setProgressPrecent(100))
	}
}
//Сага блокирование проекта из списка проектов
function* updateStatusUserProject({
	locked,
	id,
}: {
	type: typeof UserProjectsType.UPDATE_STATUS_USER_PROJECT
	locked: boolean
	id: string
}) {
	let project: IRequestProject

	try {
		project = yield call(fetchData, `/user-projects/${id}`, (res: any) => res, 'PATCH', JSON.stringify({ locked }))

		if (project && project.userProject) {
			const userProject: IUserProject = project.userProject

			yield put({ type: UserProjectsType.CHOOSE_PROJECT, project: userProject })
			yield put({ type: UserProjectsType.SET_ORIGINAL_OBJ, project: userProject })

			const currentProject: IUserProject = yield call(fetchData, `/user-projects/${id}`, (res: any) => res.userProject)

			yield put(setUserProjectInList(currentProject))

			yield put(
				showNotify({
					type: 'success',
					message: `Проект ${userProject.code} ${locked ? 'заблокирован' : 'разблокирован'}`,
				})
			)
		}
	} catch (error) {
		console.log(error)
	}
}

//Сага сохраненеия проекта
function* saveUserProject({
	body,
	isNew,
	id,
	showAlert = true,
	uncsFetch,
	resetChangedFields,
}: {
	type: typeof UserProjectsType.SAVE_USER_PROJECT
	body: IUserProject
	isNew: boolean
	id: ReactText
	showAlert: boolean
	uncsFetch: boolean
	resetChangedFields?: () => void
}) {
	const copy: IUserProject = Object.assign({}, body)

	delete copy.sumUncCost
	delete copy.userId
	delete copy.sumUncCostWithNds
	delete copy.totalInvestmentUncOffer
	delete copy.t7Id
	delete copy.t7Version
	delete copy.versions

	let project: IRequestProject

	if (!(copy.code && copy.name && copy.years)) {
		yield put(
			showNotify({
				type: 'warning',
				message: 'Не заполнены обязательные поля',
			})
		)
		return
	}

	try {
		if (isNew && !copy.unc_sort) {
			throw Error('validatonFailed')
		} else if (isNew && copy.unc_sort) {
			project = yield call(fetchData, '/user-projects', (res: any) => res, 'POST', JSON.stringify(copy))
		} else {
			project = yield call(fetchData, `/user-projects/${id}`, (res: any) => res, 'PATCH', JSON.stringify(copy))
			if (uncsFetch) yield put({ type: 'FETCH_UNCS', id: id })

			if (project?.userProject.archive !== undefined) {
				const path = project.userProject.archive
					? `/user-archive/project/${project.userProject.id}/parameters`
					: `/user-projects/project/${project.userProject.id}/parameters`

				yield put(push(path))
			}
		}

		if (project && project.userProject) {
			let userProject: IUserProject = project.userProject
			userProject = { ...userProject, locked: !!userProject.locked }

			yield put({ type: UserProjectsType.CHOOSE_PROJECT, project: userProject })
			yield put({ type: UserProjectsType.SET_ORIGINAL_OBJ, project: userProject })

			if (isNew) {
				yield put(
					showNotify({
						type: 'success',
						message: `Создан новый проект ${userProject.code}`,
					})
				)

				yield put(push(`/user-projects/project/${userProject.id}/parameters`))
				yield put({ type: 'GET_T7_DATA', id: userProject.id })
			} else {
				const delayTime = 2000
				if (showAlert) {
					yield put(
						showNotify({
							type: 'success',
							message: `Проект ${userProject.code} успешно сохранен`,
							duration: delayTime,
						})
					)
					yield put(savedUserProjectTrigger(nanoid()))
					if (resetChangedFields) {
						resetChangedFields()
					}
					yield delay(delayTime)
				}
			}

			if (project.alert) {
				const alert = project.alert
				yield put(
					showNotify({
						type: alert.type,
						message: alert.message,
					})
				)
			}
		}
	} catch (error) {
		if (error.message === 'validatonFailed') {
			yield put(
				showNotify({
					type: 'warning',
					message: `Выберите режим унц`,
				})
			)
		} else {
			console.log(error)
		}
	}
}

function* deleteUserProject({
	id,
	name,
}: {
	type: typeof UserProjectsType.DELETE_USER_PROJECT
	name: string
	id: string
}) {
	let { versions } = store.getState().userProjects.projectObj
	versions = versions?.filter(version => version.userProjectId !== Number(id))

	const res: Omit<IRequestProject, 'userProject'> = yield call(
		fetchData,
		`/user-projects/${id}`,
		(res: any) => res,
		'DELETE'
	)

	if (res.status === 'success') {
		yield put(
			showNotify({
				type: 'success',
				message: `Версия расчета ${name} успешно удалена!`,
			})
		)
		// yield put(createProjectTemplate())
		if (versions && versions?.length > 0) {
			yield put(push(`/user-projects/project/${versions[0].userProjectId}/parameters`))
		} else {
			yield put(push(`/user-projects`))
		}
	}
}

function* uncEdit(action: {
	type: typeof UserProjectsType.UNC_POSITION_EDIT
	params: {
		ids: string[]
		destination: { index: number; droppableId: string }
		source?: { index: number; droppableId: string }
	}
}) {
	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

	try {
		const { ids, destination } = action.params
		const userProjectId = store.getState().userProjects.projectObj.id

		//  извлечение номера таблицы
		const droppableId = destination?.droppableId || ''
		const tableMatch = droppableId.match(/\d+/)
		const numericTable = tableMatch ? parseInt(tableMatch[0], 10) : null

		if (!numericTable) {
			throw new Error(`Не удалось определить номер таблицы из droppableId: "${droppableId}"`)
		}

		const position = destination.index + 1
		const isTabDrop = droppableId.includes('tableTabs')

		// Обновляем каждый элемент отдельно
		for (const id of ids) {
			const body = isTabDrop ? { tableNum: numericTable } : { position, table: numericTable }

			yield call(fetchData, `/user-uncs/${id}`, (res: any) => res.userUnc, 'PATCH', JSON.stringify(body))
		}

		yield put({ type: 'FETCH_UNCS', id: userProjectId })
		// yield put({ type: 'SET_ACTIVE_UNCS', payload: [] })
	} catch (error) {
		console.error('Ошибка при переносе расценок:', error)
		yield put(
			showNotify({
				type: 'error',
				message: `Ошибка при переносе расценок`,
			})
		)
	}

	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
}

function* addUnc({
	tableNum,
	uncCellId,
	count,
	voltage,
}: {
	type: typeof UserProjectsType.ADD_UNC
	tableNum: ReactText
	uncCellId: ReactText
	count: number
	addBuffer: boolean
	voltage?: number
}) {
	try {
		yield put(loadingAddUnc(true))
		const project = store.getState().userProjects.projectObj

		let regionId: string | null = null
		let zoneId: string | null = null

		const selectedRegionRaw = localStorage.getItem('selectedRegion')
		if (selectedRegionRaw) {
			try {
				const selectedRegion = JSON.parse(selectedRegionRaw)
				if (selectedRegion) {
					if (selectedRegion.regionId) regionId = selectedRegion.regionId
					if (selectedRegion.zoneId) zoneId = selectedRegion.zoneId
				}
			} catch (e) {
				console.warn('Invalid selectedRegion in localStorage', e)
			}
		}

		// Преобразуем project.regionIds в строки и сравниваем по строкам
		const regionIds = project.regionIds || []
		const regionIdsStr = regionIds.map(id => String(id))

		if (!regionId || !regionIdsStr.includes(String(regionId))) {
			regionId = regionIds[0] ? String(regionIds[0]) : null
			zoneId = null
		}

		if (project.code === '') throw new Error('Project not defined')

		tableNum = Number(tableNum) !== 6 ? tableNum : '1'

		const body: any = {
			tableNum,
			uncCellId,
			count,
			voltage,
		}

		if (regionId !== null && zoneId !== null) {
			body.regionId = regionId
			body.region_zone_id = zoneId
		} else if (regionId !== null) {
			body.regionId = regionId
		}

		const data: IUserProject = yield call(
			fetchData,
			`/user-projects/${project.id}/user-uncs`,
			(res: any) => res.userUnc,
			'POST',
			JSON.stringify(body)
		)

		if (data) {
			const newElem: unknown = yield call(
				fetchData,
				`/user-uncs/${data.id}?with=uncMain,uncCell,regionFactor`,
				(res: any) => res.userUnc
			)

			const userProjects = store.getState().userProjects
			const buffer = produce(userProjects, draft => {
				draft.uncAddBuffer.push(newElem as IUncAddBuffer)
			})

			yield put({ type: 'SET_UNC_ADD_BUFFER', buffer: buffer.uncAddBuffer })

			// Дополнительно обновляем uncFullInfo для последней добавленной расценки
			const lastAddedUnc = buffer.uncAddBuffer[buffer.uncAddBuffer.length - 1]
			if (lastAddedUnc && lastAddedUnc.uncCell) {
				// Получаем полную информацию о расценке, включая ассисты
				const uncFullInfoResponse = yield call(
					fetchData,
					`/uncCells/${lastAddedUnc.uncCell.id}?with=voltageValues,uncCellAssist`,
					(res: any) => res.uncCell
				)

				// Сохраняем полную информацию о расценке
				yield put(setUncFullInfo(uncFullInfoResponse))

				// Проверяем наличие буфера и предыдущей информации о ассистах
				const prevUncFullInfo = userProjects.uncFullInfo

				// Если у нас уже есть предыдущие рекомендации, объединяем их с новыми
				if (prevUncFullInfo && prevUncFullInfo.uncCellAssist && uncFullInfoResponse.uncCellAssist) {
					// Объединяем рекомендации
					const mergedUncFullInfo = {
						...uncFullInfoResponse,
						uncCellAssist: {
							...uncFullInfoResponse.uncCellAssist,
						},
					}

					// Если у нас есть предыдущие обязательные расценки, объединяем их
					if (
						prevUncFullInfo.uncCellAssist.requiredUncCellIds &&
						uncFullInfoResponse.uncCellAssist.requiredUncCellIds
					) {
						// Создаем уникальный набор ID обязательных расценок
						mergedUncFullInfo.uncCellAssist.requiredUncCellIds = [
							...new Set([
								...prevUncFullInfo.uncCellAssist.requiredUncCellIds,
								...uncFullInfoResponse.uncCellAssist.requiredUncCellIds,
							]),
						]
					}

					// Если у нас есть предыдущие рекомендованные расценки, объединяем их
					if (
						Array.isArray(prevUncFullInfo.uncCellAssist.recommendUncCellIds) &&
						Array.isArray(uncFullInfoResponse.uncCellAssist.recommendUncCellIds)
					) {
						// Объединяем массивы рекомендаций
						const allRecommendations = [
							...prevUncFullInfo.uncCellAssist.recommendUncCellIds,
							...uncFullInfoResponse.uncCellAssist.recommendUncCellIds,
						]

						// Создаем новый массив рекомендаций без дубликатов
						// Сравниваем массивы по их JSON представлению
						const uniqueRecommendations = []
						const seenRecommendations = new Set()

						for (const recommendation of allRecommendations) {
							const key = JSON.stringify(recommendation)
							if (!seenRecommendations.has(key)) {
								seenRecommendations.add(key)
								uniqueRecommendations.push(recommendation)
							}
						}

						mergedUncFullInfo.uncCellAssist.recommendUncCellIds = uniqueRecommendations
					}

					// Сохраняем объединенные рекомендации
					yield put(setUncFullInfo(mergedUncFullInfo))
				}
			}
		}
	} catch (error) {
		console.log(error)
		if (error.message === 'Project not defined')
			yield put(
				showNotify({
					type: 'error',
					message: `Проект необходимо сохранить перед добавлением расценок!`,
				})
			)
	} finally {
		yield put(loadingAddUnc(false))
	}
}

function* createUncsB1({
	uncMainId,
	uncs,
	interpolated,
	tableNum,
}: {
	type: typeof UserProjectsType.CREATE_UNCS_B1
	uncMainId: number
	uncs: { [key: string]: IUnc[] }
	interpolated: number
	tableNum: ReactText
}) {
	try {
		for (const key in uncs) {
			const totalSum = uncs[key].reduce((accum: number, curr: IUnc) => (accum += curr.totalCost), 0)
			const costSum = totalSum / 1000
			yield put({
				type: UserProjectsType.CREATE_UNC_B1,
				uncMainId,
				regionId: key,
				interpolated,
				tableNum,
				count: costSum,
			})
		}
	} catch (err) {
		console.log(err)
	}
}

function* createUncB1({
	uncMainId,
	uncCellId,
	regionId,
	interpolated,
	tableNum,
	count,
}: {
	type: typeof UserProjectsType.CREATE_UNC_B1
	uncMainId: number
	uncCellId: number
	regionId: ReactText
	interpolated: number
	tableNum: ReactText
	count: number
}) {
	try {
		const { projectObj: project, activeUncs } = store.getState().userProjects

		if (project.code === '') throw new Error('Project not defined')

		const grouped = activeUncs.reduce((acc: Record<string, typeof activeUncs>, unc) => {
			const key = String(unc.regionId)
			if (!acc[key]) acc[key] = []
			acc[key].push(unc)
			return acc
		}, {})

		const allNewUncs: IUnc[] = []

		for (const regionId in grouped) {
			const group = grouped[regionId]

			if (group.length === 1) {
				const unc = group[0]

				const body = {
					tableNum,
					uncMainId,
					regionId: unc.regionId,
					region_zone_id: unc.region_zone_id,
					interpolated,
					uncCellId,
				}

				const data: IUnc = yield call(
					fetchData,
					`/user-projects/${project.id}/user-uncs`,
					(res: any) => res.userUnc,
					'POST',
					JSON.stringify(body)
				)

				if (data) {
					const uncElem: IUnc = yield call(
						fetchData,
						`/user-uncs/${data.id}`,
						(res: any) => res.userUnc,
						'PATCH',
						JSON.stringify({ count: unc.totalCost / 1000 })
					)

					const newElem: IUnc = yield call(
						fetchData,
						`/user-uncs/${data.id}?with=uncMain,uncCell,regionFactor`,
						(res: any) => res.userUnc
					)

					if (uncElem && newElem) {
						allNewUncs.push(newElem)
						yield put({ type: 'FETCH_USER_PROJECT', id: uncElem.userProjectId })
					}
				}
			} else {
				// объединяем count и берём другие поля из первого элемента
				const [first, ...rest] = group
				const totalCount = group.reduce((sum, u) => sum + (u.totalCost / 1000 || 0), 0)

				const body = {
					tableNum,
					uncMainId,
					regionId: first.regionId,
					region_zone_id: first.region_zone_id,
					interpolated,
					uncCellId,
				}

				const data: IUnc = yield call(
					fetchData,
					`/user-projects/${project.id}/user-uncs`,
					(res: any) => res.userUnc,
					'POST',
					JSON.stringify(body)
				)

				if (data) {
					const uncElem: IUnc = yield call(
						fetchData,
						`/user-uncs/${data.id}`,
						(res: any) => res.userUnc,
						'PATCH',
						JSON.stringify({ count: totalCount })
					)

					const newElem: IUnc = yield call(
						fetchData,
						`/user-uncs/${data.id}?with=uncMain,uncCell,regionFactor`,
						(res: any) => res.userUnc
					)

					if (uncElem && newElem) {
						allNewUncs.push(newElem)
						yield put({ type: 'FETCH_USER_PROJECT', id: uncElem.userProjectId })
					}
				}
			}
		}

		if (allNewUncs.length > 0) {
			const clone = store.getState().userProjects.uncs.slice()
			clone.push(...allNewUncs)
			clone.sort((a, b) => a.tableNum - b.tableNum)
			yield put({ type: 'SET_PROJECT_UNCS', uncs: clone })
		}
	} catch (error) {
		console.log(error)
		if (error.message === 'Project not defined')
			yield put(
				showNotify({
					type: 'error',
					message: `Проект необходимо сохранить перед добавлением расценок!`,
				})
			)
	}
}

function* createSpecialUnc({
	uncMainId,
	regionId,
	interpolated,
	tableNum,
}: {
	type: typeof UserProjectsType.CREATE_SPECIAL_UNC
	uncMainId: ReactText
	regionId: ReactText
	interpolated: { [key: string]: ReactText }
	tableNum: ReactText
}) {
	try {
		const project = store.getState().userProjects.projectObj

		if (project.code === '') throw new Error('Project not defined')
		tableNum = Number(tableNum) !== 6 ? tableNum : '1'
		const body: any = {
			tableNum,
			uncMainId,
			regionId,
			interpolated,
		}

		body.uncCellId = null
		const data: IUnc = yield call(
			fetchData,
			`/user-projects/${project.id}/user-uncs`,
			(res: any) => res.userUnc,
			'POST',
			JSON.stringify(body)
		)

		if (data) {
			const newElem: IUnc = yield call(
				fetchData,
				`/user-uncs/${data.id}?with=uncMain,uncCell,regionFactor`,
				(res: any) => res.userUnc
			)
			// if (newElem && newElem.interpolated) {
			// let newElemWithCount = { ...newElem, count: newElem.interpolated['interpolated'] }

			const userProjects = store.getState().userProjects
			const buffer = produce(userProjects, draft => {
				draft.uncAddBuffer.push(newElem as IUncAddBuffer)
			})
			yield put({ type: 'SET_UNC_ADD_BUFFER', buffer: buffer.uncAddBuffer })

			yield put({
				type: 'CHANGE_UNC_COUNTER',
				id: newElem.id,
				count: 0,
				inBuffer: true,
			})
		}
		// }
	} catch (error) {
		console.log(error)
		if (error.message === 'Project not defined')
			yield put(
				showNotify({
					type: 'error',
					message: `Проект необходимо сохранить перед добавлением расценок!`,
				})
			)
	}
}

//Удаление унца
function* deleteUnc({ id, inBuffer }: { type: typeof UserProjectsType.DELETE_UNC; id: ReactText; inBuffer?: boolean }) {
	try {
		yield put({ type: 'DELETE_UNC_STATUS', isDeleted: false })
		yield put(loadingUserProjects(true))

		// Сначала получаем projectId до удаления расценки
		let projectId: string | number | null = null

		try {
			const userProjects = store.getState().userProjects

			if (inBuffer) {
				const ind = userProjects.uncAddBuffer.findIndex(elem => elem.id === id)
				if (ind !== -1) {
					projectId = userProjects.uncAddBuffer[ind]?.userProjectId || null
				}
			} else {
				const uncs = userProjects.uncs
				const ind = uncs.findIndex((elem: any) => elem.id === id)
				if (ind !== -1) {
					projectId = uncs[ind]?.userProjectId || null
				}
			}
		} catch (e) {
			console.warn('Ошибка при получении projectId:', e)
		}

		// Теперь выполняем удаление
		const res: Omit<IRequestProject, 'userProject'> = yield call(
			fetchData,
			`/user-uncs/${id}`,
			(res: any) => res,
			'DELETE'
		)

		if (res.status === 'success') {
			// Обновляем состояние после успешного удаления
			if (inBuffer) {
				const userProjects = store.getState().userProjects
				const buffer = produce(userProjects, draft => {
					const index = draft.uncAddBuffer.findIndex(item => item.id === id)
					if (index !== -1) {
						draft.uncAddBuffer.splice(index, 1)
					}
				})
				yield put({ type: 'SET_UNC_ADD_BUFFER', buffer: buffer.uncAddBuffer })
			} else {
				const userProjects = store.getState().userProjects
				const clone = produce(userProjects, draft => {
					const index = draft.uncs.findIndex(item => item.id === id)
					if (index !== -1) {
						draft.uncs.splice(index, 1)
					}
				})
				yield put({ type: 'SET_PROJECT_UNCS', uncs: clone.uncs })
			}

			// Выполняем дополнительные действия только если projectId определен
			if (projectId) {
				yield put({ type: 'FETCH_USER_PROJECT', id: projectId })
				yield put({ type: 'FETCH_UNCS', id: projectId })
				yield put({ type: 'GET_PROJECT_TECH_SOLUTIONS', projectId: projectId })
			} else {
				console.warn('projectId не определен при удалении расценки с id:', id)
			}
		}
		yield put({ type: 'DELETE_UNC_STATUS', isDeleted: true })
	} catch (error) {
		yield put({ type: 'DELETE_UNC_STATUS', isDeleted: true })
		console.error('Ошибка при удалении расценки:', error)
	} finally {
		yield put(loadingUserProjects(false))
	}
}

function* replaceUnc({
	oldUncId,
	newUncId,
}: {
	type: typeof UserProjectsType.REPLACE_UNC
	oldUncId: string
	newUncId: string
}) {
	try {
		const res: any = yield call(
			fetchData,
			`/user-uncs/${oldUncId}/setAnalog`,
			(res: any) => res,
			'PATCH',
			JSON.stringify({ uncCellId: newUncId })
		)

		const userProjects = store.getState().userProjects

		yield put({ type: UserProjectsType.FETCH_UNCS, id: res.userUnc.userProjectId })

		yield put({ type: 'FETCH_USER_PROJECT', id: userProjects.originalObj.id })
	} catch (error) {
		console.log(error)
	}
}

function* genAnalogUnc({ id }: { type: typeof UserProjectsType.GET_ANALOG_UNC; id: ReactText }) {
	try {
		const res: any = yield call(fetchData, `/uncCells/${id}/getAnalogs/`, (res: any) => res, 'GET')

		if (res.status === 'success') {
			yield put(setAnalogUncList(res.uncCells))
		}
	} catch (error) {
		console.log(error)
	}
}

function* fetchAssistStatus() {
	try {
		const userId = store.getState().auth.user.id

		const res: any = yield call(fetchData, `/user-settings?userId=${userId}`, (res: any) => res, 'GET')
		if (res.status === 'success') {
			yield put(setAssistStatus(res.userSettings[0].enableUncAssist))
		}
	} catch (error) {
		console.log(error)
	}
}

function* changeAssistStatus(changes: any) {
	try {
		const userId = store.getState().auth.user.id
		yield call(
			fetchData,
			`/user-settings?userId=${userId}`,
			(res: any) => res,
			'POST',
			JSON.stringify({ enableUncAssist: changes?.enableUncAssist })
		)
	} catch (error) {
		console.log(error)
	}
}

function* changeRegionFactor({ id, uncTableId, regionId }: any) {
	// try {
	// 	const region = yield call(
	// 		fetchData,
	// 		`/region-factors/search?uncTableId=${uncTableId}&regionId=${regionId}`,
	// 		(res: any) => res.regionFactor
	// 	)
	// 	const res = yield call(fetchData, `/uncs/${id}`, (res: any) => res.unc, 'PATCH', JSON.stringify({ regionId }))
	// 	let uncTable = store.getState().formTwenty.uncTable,
	// 		ind = searchByKey(uncTable, 'id', id)
	// 	let clone = uncTable.slice()
	// 	res.regionFactor = region
	// 	res.uncTable = clone[ind].uncTable
	// 	clone.splice(ind, 1, res)
	// 	yield put({ type: 'UPDATE_UNC_TABLE', uncTable: clone })
	// } catch (error) {
	// 	console.log(error)
	// }
}

function* changeFormTwentyName({ name }: any) {
	// try {
	// 	const id = store.getState().formTwenty.id
	// 	yield call(fetchData, `/projects/${id}`, res => res, 'PATCH', JSON.stringify({ name }))
	// } catch (error) {
	// 	console.log(error)
	// }
}

//Сага загрузки проектов
function* getMyProjects() {
	try {
		const projects: Omit<IAllRequestProject, 'userProject'> = yield call(fetchData, '/user-projects', (res: any) => res)

		if (projects) {
			yield put({
				type: 'SET_USER_PROJECTS',
				projects: projects.userProjects,
				userProjectsCnt: projects.userProjectsCnt,
				totalInvestmentUncOfferSum: Number(projects.totalInvestmentUncOfferSum),
			})
		}
	} catch (error) {
		console.log(error)
	}
}

//Сага загрузки таблицы унцов проекта
function* fetchUncs({ id }: { type: typeof UserProjectsType.FETCH_UNCS; id: string }) {
	try {
		yield put(setFetchFailure(false))
		const uncs: IUnc = yield call(
			fetchData,
			`/user-projects/${id}/user-uncs?with=uncMain,uncCell,regionFactor`,
			(res: any) => res.userUncs
		)
		if (uncs) {
			yield put({ type: 'SET_PROJECT_UNCS', uncs })
		}
	} catch (error) {
		console.log(error)
		yield put(setFetchFailure(true))
	}
}

//Сага загрузки таблицы унцов проекта
function* fetchNonStandardizedCosts() {
	try {
		const nonStandardizedCosts: IUnnormalizedListItem[] = yield call(
			fetchData,
			`/unnormalizedList`,
			(res: any) => res.unnormalizedList
		)
		if (nonStandardizedCosts) {
			yield put({ type: 'SET_NON_STANDARDIZED_COSTS', non_standardized_costs: nonStandardizedCosts })
		}
	} catch (error) {
		console.log(error)
	}
}

//Сага загрузки таблицы унцов для добавления в проект
function* fetchUncTableData({
	id,
	unc_sort,
}: {
	type: typeof UserProjectsType.FETCH_UNC_TABLE_DATA
	id: number
	unc_sort: string
}) {
	try {
		let uncTable
		if (id) {
			uncTable = yield call(fetchData, `/unc-mains/${id}?with=uncTable`, (res: any) => res[`uncMain`])
		}
		if (uncTable) {
			yield put({ type: 'SET_UNC_TABLE_DATA', uncTableData: uncTable.uncTable })
		} else {
			yield put({ type: 'SET_UNC_TABLE_DATA', uncTableData: null })
		}
	} catch (error) {
		console.log(error)
	}
}

// Сага изменения комментария расценки
function* changeUncComment({
	id,
	objectName,
	stage,
	kf,
	description,
	comment,
	complicating_params,
	kfConfirm,
}: {
	type: typeof UserProjectsType.CHANGE_UNC_COMMENT
	id: ReactText
	objectName: string
	stage: string
	kf: any
	description: string
	comment: string
	complicating_params: any
	kfConfirm?: boolean | number
}) {
	try {
		const uncElem: IUnc = yield call(
			fetchData,
			`/user-uncs/${id}`,
			(res: any) => res.userUnc,
			'PATCH',
			JSON.stringify({
				objectName,
				stage,
				...kf,
				description,
				comment,
				complicating_params,
				kf_confirmed: kfConfirm ? 1 : 0,
			})
		)

		if (uncElem) {
			yield put(fetchUncsForUpdate(uncElem.userProjectId as string))
			const userProjects = store.getState().userProjects
			const ind = userProjects.uncs.findIndex(elem => elem.id === id)
			const indActiveUncs = userProjects.activeUncs.findIndex(elem => elem.id === id)
			const cloneUnc = produce(userProjects, draft => {
				draft.uncs[ind].objectName = uncElem.objectName
				draft.uncs[ind].stage = uncElem.stage
				draft.uncs[ind].kf = uncElem.kf
				draft.uncs[ind].description = uncElem.description
				draft.uncs[ind].comment = uncElem.comment
				draft.uncs[ind].totalCost = uncElem.totalCost
				draft.uncs[ind].complicating_params = uncElem.complicating_params
			})
			const cloneActiveUncs = produce(userProjects, draft => {
				draft.activeUncs[indActiveUncs].objectName = uncElem?.objectName
				draft.activeUncs[indActiveUncs].stage = uncElem.stage
				draft.activeUncs[indActiveUncs].kf = uncElem.kf
				draft.activeUncs[indActiveUncs].description = uncElem.description
				draft.activeUncs[indActiveUncs].comment = uncElem.comment
				draft.uncs[ind].totalCost = uncElem.totalCost
				draft.uncs[ind].complicating_params = uncElem.complicating_params
			})
			yield put(setActiveUncs([cloneActiveUncs.activeUncs[indActiveUncs]]))
			yield put({ type: 'SET_PROJECT_UNCS', uncs: cloneUnc.uncs })
		}
	} catch (error) {
		console.log(error)
	}
}
// Сага изменения комментария расценки
function* changeUncCfArchitecture({
	id,
	complicating_params,
}: {
	type: typeof UserProjectsType.CHANGE_UNC_CF_ARCHITECTURE
	id: ReactText
	complicating_params: any
}) {
	try {
		const uncElem: IUnc = yield call(
			fetchData,
			`/user-uncs/${id}`,
			(res: any) => res.userUnc,
			'PATCH',
			JSON.stringify({ complicating_params })
		)

		if (uncElem) {
			yield put(fetchUncsForUpdate(uncElem.userProjectId as string))
			const userProjects = store.getState().userProjects
			const ind = userProjects.uncs.findIndex(elem => elem.id === id)
			const indActiveUncs = userProjects.activeUncs.findIndex(elem => elem.id === id)
			const cloneUnc = produce(userProjects, draft => {
				draft.uncs[ind].objectName = uncElem.objectName
				draft.uncs[ind].stage = uncElem.stage
				draft.uncs[ind].kf = uncElem.kf
				draft.uncs[ind].description = uncElem.description
				draft.uncs[ind].comment = uncElem.comment
				draft.uncs[ind].totalCost = uncElem.totalCost
				draft.uncs[ind].complicating_params = uncElem.complicating_params
			})
			yield put({ type: 'SET_PROJECT_UNCS', uncs: cloneUnc.uncs })
		}
	} catch (error) {
		console.log(error)
	}
}
//Сага изменения количества единиц расценки
function* changeUncCounter({
	id,
	count,
	inBuffer,
}: {
	type: typeof UserProjectsType.CHANGE_UNC_COUNTER
	id: ReactText
	count: string
	inBuffer?: boolean | undefined
}) {
	try {
		const uncElem: IUnc = yield call(
			fetchData,
			`/user-uncs/${id}`,
			(res: any) => res.userUnc,
			'PATCH',
			JSON.stringify({ count })
		)
		if (uncElem) {
			const userProjects = store.getState().userProjects

			if (inBuffer) {
				const ind = userProjects.uncAddBuffer.findIndex(elem => elem.id === id)
				const copyBuffer = produce(userProjects, draft => {
					if (draft.uncAddBuffer[ind]) draft.uncAddBuffer[ind] = Object.assign(draft.uncAddBuffer[ind], uncElem)
				})
				const clone = produce(userProjects, draft => {
					const unc = draft.uncs.find(unc => unc.id === uncElem.id)

					if (unc) {
						unc.count = uncElem.count
						unc.totalCost = uncElem.totalCost
					}
				})
				// yield put({ type: 'SET_PROJECT_UNCS', uncs: clone.uncs })
				yield put({ type: 'SET_UNC_ADD_BUFFER', buffer: copyBuffer.uncAddBuffer })
			} else {
				const ind = userProjects.uncs.findIndex((elem: any) => elem.id === uncElem.id)
				const clone = produce(userProjects, draft => {
					const unc = draft.uncs.find(unc => unc.id === uncElem.id)

					if (unc) {
						unc.count = uncElem.count
						unc.totalCost = uncElem.totalCost
					}
				})
				yield put({ type: 'SET_PROJECT_UNCS', uncs: clone.uncs })
				yield put({ type: 'FETCH_USER_PROJECT', id: uncElem.userProjectId })
			}
			yield put({ type: 'FETCH_UNCS', id: uncElem.userProjectId })
			yield put({ type: 'GET_PROJECT_TECH_SOLUTIONS', projectId: uncElem.userProjectId, order: 'id' })
		}
	} catch (error) {
		console.log(error)
	}
}

//Сага изменения региона расценки
function* changeUncRegion({
	id,
	regionId,
	zoneId,
}: {
	type: typeof UserProjectsType.CHANGE_UNC_REGION
	id: ReactText
	regionId: ReactText
	zoneId?: ReactText
}) {
	try {
		const uncElem: IUnc = yield call(
			fetchData,
			`/user-uncs/${id}?with=regionFactor`,
			(res: any) => res.userUnc,
			'PATCH',
			JSON.stringify({ regionId, region_zone_id: zoneId })
		)
		if (uncElem) {
			const userProjects = store.getState().userProjects
			const ind = userProjects.uncs.findIndex((elem: any) => elem.id === uncElem.id)
			const clone = produce(userProjects, draft => {
				draft.uncs[ind] = Object.assign(draft.uncs[ind], uncElem)
			})
			yield put({ type: 'SET_PROJECT_UNCS', uncs: clone.uncs })
			yield put({ type: 'FETCH_USER_PROJECT', id: uncElem.userProjectId })
			yield put({ type: 'FETCH_UNCS', id: uncElem.userProjectId })
		}
	} catch (error) {
		console.log(error)
	}
}

//Сага изменения напряжения расценки
function* changeUncVoltage({
	id,
	voltage,
	inBuffer,
}: {
	type: typeof UserProjectsType.CHANGE_UNC_VOLTAGE
	id: string
	voltage: number
	inBuffer?: boolean
}) {
	try {
		const uncElem: IUnc = yield call(
			fetchData,
			`/user-uncs/${id}`,
			(res: any) => res.userUnc,
			'PATCH',
			JSON.stringify({ voltage })
		)
		if (uncElem) {
			const userProjects = store.getState().userProjects

			if (inBuffer) {
				const ind = userProjects.uncAddBuffer.findIndex(elem => elem.id === id)
				const copyBuffer = produce(userProjects, draft => {
					draft.uncAddBuffer[ind] = Object.assign(draft.uncAddBuffer[ind], uncElem)
				})

				yield put({ type: 'SET_UNC_ADD_BUFFER', buffer: copyBuffer.uncAddBuffer })
			} else {
				const ind = userProjects.uncs.findIndex((elem: any) => elem.id === uncElem.id)
				const clone = produce(userProjects, draft => {
					draft.uncs[ind] = Object.assign(draft.uncs[ind], uncElem)
				})
				yield put({ type: 'SET_PROJECT_UNCS', uncs: clone.uncs })
			}
			yield put({ type: 'FETCH_UNCS', id: uncElem.userProjectId })
		}
	} catch (error) {
		console.log(error)
	}
}
function* handleUncCells() {
	try {
		const uncCells: IUncMain[] = yield call(fetchData, '/uncCells?unc_sort=2024', (res: any) => res.uncCells)
		yield put(setUncCells(uncCells))
	} catch (error) {
		console.log(error)
	}
}
function* selectVoltage({
	uncCellId,
	uncId,
}: {
	type: typeof UserProjectsType.SELECT_VOLTAGE
	uncCellId: ReactText
	uncId: ReactText
}) {
	try {
		const uncFullInfo = store.getState().userProjects.uncFullInfo
		const uncCell: IUncCell = yield call(
			fetchData,
			`/uncCells/${uncCellId}?with=voltageValues,uncCellAssist`,
			(res: any) => res.uncCell
		)
		if (!uncFullInfo) {
			yield put({
				type: 'SET_UNC_FULL_INFO',
				voltage: uncCell,
			})
		}
		yield put({
			type: 'SET_VOLTAGE',
			uncId,
			targetVoltageValues: uncCell.voltageValues,
		})
		yield put({
			type: 'GET_UNC_CELLS',
		})
		yield put({ type: 'SET_VOLTAGE_ID', uncId, targetVoltageId: uncId })
	} catch (error) {
		console.log(error)
	}
}

function* updateDeflators({
	start,
	end,
	transit,
}: {
	type: typeof UserProjectsType.UPDATE_DEFLATORS
	start: ReactText
	end: ReactText
	transit?: boolean
}) {
	const userProjects = store.getState().userProjects

	try {
		const deflators: { [key: string]: string } = yield call(
			fetchData,
			`/info/deflators?year_min=${start}&year_max=${end}`,
			(res: any) => res.deflators
		)

		if (deflators) {
			if (userProjects.projectObj.unc_sort === '2024') {
				const originalObj: any = Object.assign({}, store.getState().userProjects.projectObj),
					editObj = Object.assign({}, store.getState().userProjects.projectObj)

				const years: any = {}
				let accumulatedOffer = 0

				for (let i = 2018; i <= +end; i++) {
					if (i < +start && originalObj.years[i]) {
						accumulatedOffer += originalObj.years[i].offer || 0
					} else if (i === +start) {
						if (transit) {
							years[i] = {
								offer: originalObj.years[i]?.offer || 0,
								deflator: originalObj.years[i]?.deflator ?? deflators?.[i] ?? 0,
							}
						} else {
							years[i] = {
								offer: originalObj.years[i]?.offer + accumulatedOffer || 0,
								deflator: originalObj.years[i]?.deflator ?? deflators?.[i] ?? 0,
							}
						}
					} else if (i > +start) {
						// Если год >= start, записываем данные
						years[i] = {
							offer: originalObj.years[i]?.offer || 0,
							deflator: originalObj.years[i]?.deflator ?? deflators?.[i] ?? 0,
						}
					}
				}

				const fullFunding = originalObj.actualFunding + accumulatedOffer
				editObj.years = years
				if (transit) {
					editObj.actualFunding = fullFunding
				}
				yield put({ type: 'CHOOSE_PROJECT', project: editObj })
			} else {
				const originalObj: any = Object.assign({}, store.getState().userProjects.originalObj),
					editObj = Object.assign({}, store.getState().userProjects.projectObj)

				const years: any = {}
				let accumulatedOffer = 0

				for (let i = 2018; i <= +end; i++) {
					if (i < +start && originalObj.years[i]) {
						accumulatedOffer += originalObj.years[i].offer || 0
					} else if (i === +start) {
						years[i] = {
							offer: originalObj.years[i]?.offer + accumulatedOffer || 0,
							deflator: originalObj.years[i]?.deflator ?? deflators?.[i] ?? 0,
						}
					} else if (i > +start) {
						// Если год >= start, записываем данные
						years[i] = {
							offer: originalObj.years[i]?.offer || 0,
							deflator: originalObj.years[i]?.deflator ?? deflators?.[i] ?? 0,
						}
					}
				}

				// const years: any = originalObj.years
				editObj.years = years
				if (transit) {
					editObj.actualFunding = originalObj.actualFunding ? originalObj.actualFunding : 0
				}

				yield put({ type: 'CHOOSE_PROJECT', project: editObj })
			}
		}
	} catch (error) {
		console.log(error)
	}
}

function* getAllDeflators() {
	try {
		yield put({ type: AdminPanelType.LOADING_SETTINGS, loading: true })
		const { deflators, precision }: { deflators: { year: number; value: string }[]; precision: number } = yield call(
			fetchData,
			`/deflator`,
			(res: any) => res
		)

		yield put({ type: UserProjectsType.SET_DEFLATORS, deflators: deflators, precision })
	} catch (error) {
		console.log(error)
	} finally {
		yield put({ type: AdminPanelType.LOADING_SETTINGS, loading: false })
	}
}

function* updateDeflatorsValue({
	deflators,
}: {
	type: typeof UserProjectsType.UPDATE_DEFLATORS_VALUE
	deflators: any
}) {
	try {
		yield call(fetchData, `/deflator`, (res: any) => res, 'POST', JSON.stringify({ ...deflators }))

		yield put(
			showNotify({
				type: 'success',
				message: `Индексы-дефляторы обновлены!`,
			})
		)
	} catch (error) {
		console.log(error)
	}
}

function* getCheckedErrors({
	id,
	sectionIdsArr,
}: {
	type: typeof UserProjectsType.GET_CHECKED_ERRORS
	id: ReactText | undefined
	sectionIdsArr: number[]
}) {
	try {
		yield put(checkMassErrorLoad(false))
		const errors: any = yield call(
			fetchData,
			`/user-projects/${id}/rule-error?with=messages`,
			(res: any) => res.userRuleError,
			'POST',
			JSON.stringify({ sectionIds: sectionIdsArr })
		)

		if (errors) {
			yield put({
				type: 'SET_PROJECT_ERRORS',
				errors: errors.messages,
			})
			yield put({ type: 'SHOW_PROJECT_ERRORS', show: true })
		} else {
			yield put(showNotify({ type: 'error', message: 'Ошибка проверки. Попробуйте снова.' }))
			yield put({ type: 'SHOW_PROJECT_ERRORS', show: false })
			yield put(checkMassErrorLoad(true))
		}
	} catch (error) {
		console.log(error)
	}
}
function* autoAddUnc({
	id,
	sectionIdsArr,
}: {
	type: typeof UserProjectsType.AUTO_ADD_UNC
	id: ReactText | undefined
	sectionIdsArr: number[]
}) {
	try {
		const errors: ICheckedErrors = yield call(
			fetchData,
			`/user-projects/${id}/autoAddUnc`,
			(res: any) => res.userRuleError,
			'POST',
			JSON.stringify({ sectionIds: sectionIdsArr })
		)

		if (errors) {
			yield put({
				type: 'SET_PROJECT_ERRORS',
				errors: errors.messages,
			})
			yield put(fetchUncsForUpdate(String(id)))
		} else {
			yield put({ type: 'SET_PROJECT_ERRORS', errors: '0' })
		}

		yield put({ type: 'SHOW_PROJECT_ERRORS', show: true })
	} catch (error) {
		console.log(error)
	}
}

function* downloadRulesCheck() {
	try {
		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}/ptk/v2/rules`, {
			method: 'GET',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				Authorization: `Bearer ${localStorage.getItem('access_token')}`,
			},
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = 'Правила проверки.xlsx'
				link.click()
				link.remove()
			})
	} catch (error) {
		console.log(error)
	}
}
function* downloadImportLog({ linked }: { type: typeof UserProjectsType.SET_DOWNLOAD_IMPORT_DATA; linked: string }) {
	try {
		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}${linked}`, {
			method: 'GET',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				Authorization: `Bearer ${localStorage.getItem('access_token')}`,
			},
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = 'ImportData.xlsx'
				link.click()
				link.remove()
			})
	} catch (error) {
		console.log(error)
	}
}

function* downloadTemplate({ link }: { type: typeof UserProjectsType.DOWNLOAD_TEMPLATE; link: string }) {
	try {
		const fileName = link
		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${link}`, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = `${fileName}.xlsx`
				link.click()
				link.remove()
				setProgressPrecent(100)
			})

		yield put(setLoadingStates('', false))
	} catch (error) {
		console.log(error)
	}
}

function* importTechSolutions({ file }: { type: typeof UserProjectsType.IMPORT_TECH_SOLUTIONS; file: any }) {
	const fileTypes = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
	if (!fileTypes.includes(file.type)) {
		yield put(
			showNotify({
				type: 'warning',
				message: 'Неверный формат файла! Допустимый формат - *.xlsx',
			})
		)
		return
	}

	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

	const data = new FormData()
	data.append('file', file, file.name)

	const requestUrl = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-tech-solutions/importTechSolutions`

	let retry = false
	let isAlreadyFetchingAccessToken = false
	let attempts = 0
	const maxAttempts = 2

	try {
		do {
			if (attempts >= maxAttempts) {
				yield put(showNotify({ type: 'error', message: 'Не удалось загрузить файл. Попробуйте позже.' }))
				break
			}
			attempts++

			const response: Response = yield call(() =>
				fetch(requestUrl, {
					method: 'POST',
					body: data,
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						Authorization: `Bearer ${localStorage.getItem('access_token')}`,
					},
				})
			)

			if (response.status === 401 && !isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true
				try {
					const refresh_token = localStorage.getItem('refresh_token') || ''
					if (!refresh_token) throw new Error('Refresh token not found')

					const { access_token } = yield call(refreshToken, refresh_token)
					if (!access_token) throw new Error('Access token not returned')

					localStorage.setItem('access_token', access_token)
					retry = true
				} catch (authError) {
					console.error('Ошибка авторизации:', authError)
					yield put(showNotify({ type: 'error', message: 'Ошибка авторизации. Попробуйте снова.' }))
					break
				} finally {
					isAlreadyFetchingAccessToken = false
				}
				continue
			}

			if (!response.ok) {
				yield put(showNotify({ type: 'error', message: 'Ошибка загрузки файла, попробуйте позже.' }))
				break
			}

			retry = false

			// JSON-ответ
			if (response.headers.get('content-type')?.includes('application/json')) {
				const success = yield response.json()

				if (success.status === 'failure') {
					yield put(showNotify({ type: 'error', message: success.message || 'Ошибка загрузки файла' }))
				} else {
					const { errors, reportUrl, added, updated } = success.done
					if (errors?.length > 0) {
						yield put(setDataImportMagazine(errors, reportUrl))
						yield put(setOpenModalImportMagazine(true))
						yield put(
							showNotify({
								type: 'error',
								message: errors.join(', '),
							})
						)
					}
					yield put(
						showNotify({
							type: 'success',
							message: `Файл успешно загружен! Добавлено: ${added}, Обновлено: ${updated}`,
						})
					)
				}
			}

			// Потоковый ответ
			else if (response.body) {
				const reader = response.body.getReader()
				const decoder = new TextDecoder('utf-8')
				let buffer = ''
				let finalJsonBuffer = ''

				while (true) {
					const { done, value } = yield call([reader, reader.read])
					buffer += decoder.decode(value, { stream: true })

					let boundary = buffer.indexOf('\n')
					while (boundary !== -1) {
						const chunk = buffer.slice(0, boundary).trim()
						buffer = buffer.slice(boundary + 1)

						if (chunk.startsWith('data:')) {
							const percent = parseInt(chunk.replace('data:', '').trim())
							if (!isNaN(percent)) {
								yield put(setProgressPrecent(percent))
							}
						} else if (chunk) {
							finalJsonBuffer = chunk
						}

						boundary = buffer.indexOf('\n')
					}

					if (done) {
						if (buffer.trim()) {
							finalJsonBuffer = buffer.trim()
						}
						if (finalJsonBuffer) {
							try {
								const parsed = JSON.parse(finalJsonBuffer)

								if (parsed.status === 'failure') {
									yield put(showNotify({ type: 'error', message: parsed.message }))
								} else if (parsed.done) {
									const { errors, reportUrl, updated, added } = parsed.done
									if (errors?.Error?.length || errors?.Notice?.length) {
										yield put(setDataImportMagazine(errors, reportUrl))
										yield put(setOpenModalImportMagazine(true))
									}
									yield put(
										showNotify({
											type: 'success',
											message: `Файл успешно загружен! Добавлено: ${added}, Обновлено: ${updated}`,
										})
									)
								}
							} catch (e) {
								console.error('Ошибка парсинга JSON из потока: ', e)
							}
						}
						yield put(setProgressPrecent(0))
						break
					}
				}
			}
		} while (retry)

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.error('Ошибка при импорте:', error)
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
		yield put(
			showNotify({
				type: 'error',
				message: 'Ошибка обработки файла, попробуйте позже.',
			})
		)
	}
}

function* uploaderRulesCheck(file: any) {
	try {
		const target = file.file[0]
		const fileTypes = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
		if (!fileTypes.includes(target.type)) {
			yield put(showNotify({ type: 'warning', message: `Неверный формат файла! Допустимый формат - *.xlsx` }))
			return
		}

		const data = new FormData()
		data.append('file', target, target.name)

		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}/ptk/v2/rules`, {
			method: 'POST',
			body: data,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				Authorization: `Bearer ${localStorage.getItem('access_token')}`,
			},
		})
			.then(response => response.json())
			.then(success => {
				if (success.status === 'failure') {
					store.dispatch(
						showNotify({
							type: 'error',
							message: 'Ошибка загрузки файла, проверьте файл или попробуйте позже.',
						})
					)
				} else {
					store.dispatch(
						showNotify({
							type: 'success',
							message: 'Файл успешно загружен!',
						})
					)
				}
			})
			.catch(error => {
				store.dispatch(
					showNotify({
						type: 'error',
						message: 'Ошибка загрузки файла, попробуйте позже.',
					})
				)
			})
	} catch (error) {
		yield put(
			showNotify({
				type: 'error',
				message: 'Ошибка загрузки файла, попробуйте позже.',
			})
		)
	}
}

function* massCheck({ sectionIdsArr }: { type: typeof UserProjectsType.MASS_CHECK; sectionIdsArr: number[] }) {
	const { userProjects } = store.getState().filter
	const { sort, projectList } = store.getState().userProjects

	let params = {
		order: (sort ? '' : '-') + sort.sortName,
		limit: projectList.length,
	}

	const object = excludeData(userProjects.showFilterState)
	const intermediateValue = { ...object }

	if (userProjects.showFilterState || Object.keys(intermediateValue).length > 0) {
		params = { ...params, ...intermediateValue }
	}

	const paramsString = Object.entries(params)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&')

	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/rule-error-many?${paramsString}&with=messages`

	let isAlreadyFetchingAccessToken = false
	let retry = false
	let attempts = 0
	const maxAttempts = 2

	yield put({ type: 'MASS_CHECK_LOADER', loading: true })

	do {
		try {
			if (attempts >= maxAttempts) {
				yield put(showNotify({ type: 'error', message: 'Не удалось выполнить проверку. Попробуйте позже.' }))
				break
			}

			attempts++

			const response: Response = yield call(() =>
				fetch(url, {
					method: 'POST',
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						'Content-Type': 'application/json',
						Authorization: `Bearer ${localStorage.getItem('access_token')}`,
					},
					body: JSON.stringify({ sectionIds: sectionIdsArr }),
				})
			)

			if (response.status === 401 && !isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true

				try {
					const refresh_token = localStorage.getItem('refresh_token') || ''
					if (!refresh_token) throw new Error('Refresh token is missing')

					const { access_token } = yield call(refreshToken, refresh_token)
					if (!access_token) throw new Error('Access token not returned')

					onAccessTokenFetched(access_token)
					retry = true
				} catch (authError) {
					console.error('Ошибка авторизации:', authError)
					yield put(
						showNotify({
							type: 'error',
							message: 'Ошибка авторизации. Попробуйте снова.',
						})
					)
					break
				} finally {
					isAlreadyFetchingAccessToken = false
				}

				continue
			}

			if (!response.ok) {
				yield put(showNotify({ type: 'error', message: 'Произошла ошибка формирования отчета.' }))
				break
			}

			retry = false

			if (response.headers.get('content-type')?.includes('application/json')) {
				const errors = yield response.json()

				if (errors) {
					const prepared = errors.map(({ userProjectCode, messages, id }: ICheckedMassErrors) => ({
						userProjectCode,
						messages,
						id,
					}))

					yield put(setMassErrors(prepared))
				} else {
					yield put(setMassErrors(null))
				}
			} else if (response.body) {
				// stream mode
				const reader = response.body.getReader()
				const decoder = new TextDecoder('utf-8')
				let buffer = ''
				let finalJsonBuffer = ''

				while (true) {
					const { done, value } = yield call([reader, reader.read])
					if (done) break

					buffer += decoder.decode(value, { stream: true })

					let boundary = buffer.indexOf('\n')
					while (boundary !== -1) {
						const chunk = buffer.slice(0, boundary).trim()
						buffer = buffer.slice(boundary + 1)

						if (chunk.startsWith('data:')) {
							const dataValue = chunk.replace('data:', '').trim()
							const progressPercent = parseInt(dataValue)
							if (!isNaN(progressPercent)) {
								yield put(setProgressPrecent(progressPercent))
							}
						} else if (chunk) {
							finalJsonBuffer = chunk
						}

						boundary = buffer.indexOf('\n')
					}
				}

				// Final buffer
				if (buffer.trim()) {
					finalJsonBuffer = buffer.trim()
				}

				if (finalJsonBuffer) {
					try {
						const errors = JSON.parse(finalJsonBuffer)
						const prepared = errors?.userRuleError?.map(({ userProjectCode, messages, id }: ICheckedMassErrors) => ({
							userProjectCode,
							messages,
							id,
						}))

						yield put(setMassErrors(prepared || null))
					} catch (e) {
						console.error('Ошибка парсинга:', e)
						yield put(setMassErrors(null))
					}
				}
			}

			break // завершить do...while
		} catch (error) {
			console.error(error)
			yield put(
				showNotify({
					type: 'error',
					message: 'Произошла ошибка при массовой проверке.',
				})
			)
			break
		}
	} while (retry)

	yield put({ type: 'MASS_CHECK_LOADER', loading: false })
	yield put(setProgressPrecent(0))
}

function* downloadForm2({ id, name }: { type: typeof UserProjectsType.DOWNLOAD_F2; id: ReactText; name: string }) {
	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/forma2`

	const { userProjects } = store.getState().filter
	const { sort, projectList } = store.getState().userProjects

	let params = { order: (sort ? '' : '-') + sort.sortName, limit: projectList.length }
	const object = excludeData(userProjects.showFilterState)
	const intermediateValue = {
		...object,
	}
	if (userProjects.showFilterState || !!Object.keys(intermediateValue).length) {
		params = {
			...params,
			...intermediateValue,
		}
	}

	const paramsString = Object.entries(params)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&')

	try {
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })
		const avg_time_per_project = 0.10588235
		const expected_time = avg_time_per_project * Number(userProjects.countResult)
		const progressTask = yield fork(updateProgressDuringRequest, expected_time)
		yield call(() =>
			fetchWith401Retry(url + '?' + paramsString, {
				method: 'GET',
				headers: fetchHeaders(),
			})
				.then(res => res.blob())
				.then(blob => {
					const url = URL.createObjectURL(blob),
						link = document.createElement('a')
					document.body.appendChild(link)
					link.href = url
					link.download = `Форма 2.xlsx`
					link.click()
					link.remove()
				})
		)
		yield cancel(progressTask)
		yield put(setProgressPrecent(100))
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.log(error)
	} finally {
		yield put(setProgressPrecent(0))
	}
}

function* uploadForm2({
	file,
	importInto,
	uncSort,
	companyId,
	url,
}: {
	type: typeof UserProjectsType.UPLOAD_F2
	file: any
	importInto: string
	uncSort: string
	companyId: string
	url: string
}) {
	const fileTypes = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
	if (!fileTypes.includes(file[0].type)) {
		yield put(showNotify({ type: 'warning', message: 'Неверный формат файла! Допустимый формат - *.xlsx' }))
		return
	}

	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

	const data = new FormData()
	data.append('file', file[0], file[0].name)

	const requestUrl = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/uploadForm2?importInto=${importInto}&uncSort=${uncSort}&companyId=${companyId}`

	let retry = false
	let isAlreadyFetchingAccessToken = false
	let attempts = 0
	const maxAttempts = 2

	try {
		do {
			if (attempts >= maxAttempts) {
				yield put(showNotify({ type: 'error', message: 'Не удалось загрузить файл. Повторите позже.' }))
				break
			}
			attempts++

			const response: Response = yield call(() =>
				fetch(requestUrl, {
					method: 'POST',
					body: data,
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						Authorization: `Bearer ${localStorage.getItem('access_token')}`,
					},
				})
			)

			if (response.status === 401 && !isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true
				try {
					const refresh_token = localStorage.getItem('refresh_token') || ''
					if (!refresh_token) throw new Error('Refresh token not found')

					const { access_token } = yield call(refreshToken, refresh_token)
					if (!access_token) throw new Error('Access token not returned')

					onAccessTokenFetched(access_token)
					retry = true
				} catch (authError) {
					console.error('Ошибка авторизации:', authError)
					yield put(showNotify({ type: 'error', message: 'Ошибка авторизации. Попробуйте снова.' }))
					break
				} finally {
					isAlreadyFetchingAccessToken = false
				}
				continue
			}

			if (!response.ok) {
				yield put(showNotify({ type: 'error', message: 'Ошибка загрузки файла, попробуйте позже.' }))
				break
			}

			retry = false

			// JSON-ответ
			if (response.headers.get('content-type')?.includes('application/json')) {
				const result = yield response.json()

				if (result.status === 'failure') {
					yield put(showNotify({ type: 'error', message: result.message || 'Ошибка загрузки файла' }))
				} else {
					const { errors, reportUrl, added, updated } = result.done
					if (errors?.length > 0) {
						yield put(setDataImportMagazine(errors, reportUrl))
						yield put(setOpenModalImportMagazine(true))
						yield put(
							showNotify({
								type: 'error',
								message: errors.map((item: string) => item).join(', '),
							})
						)
					}
					yield put(
						showNotify({
							type: 'success',
							message: `Файл успешно загружен! Добавлено проектов: ${added}, Обновлено: ${updated}`,
						})
					)
				}
			}
			// Потоковый ответ
			else {
				const reader = response.body?.getReader()
				if (!reader) throw new Error('Не удалось прочитать поток')

				const decoder = new TextDecoder('utf-8')
				let buffer = ''
				let finalJsonBuffer = ''

				while (true) {
					const { done, value } = yield call([reader, reader.read])
					buffer += decoder.decode(value, { stream: true })

					let boundary = buffer.indexOf('\n')
					while (boundary !== -1) {
						const chunk = buffer.slice(0, boundary).trim()
						buffer = buffer.slice(boundary + 1)

						if (chunk.startsWith('data:')) {
							const progress = parseInt(chunk.replace('data:', '').trim())
							if (!isNaN(progress)) {
								yield put(setProgressPrecent(progress))
							}
						} else if (chunk) {
							finalJsonBuffer = chunk
						}

						boundary = buffer.indexOf('\n')
					}

					if (done) {
						if (buffer.trim()) {
							finalJsonBuffer = buffer.trim()
						}

						if (finalJsonBuffer) {
							try {
								const parsed = JSON.parse(finalJsonBuffer)

								if (parsed.status === 'failure') {
									yield put(showNotify({ type: 'error', message: parsed.message }))
								} else if (parsed.done) {
									const { errors, reportUrl, updated, added } = parsed.done
									if (errors?.Error?.length || errors?.Notice?.length) {
										yield put(setDataImportMagazine(errors, reportUrl))
										yield put(setOpenModalImportMagazine(true))
									}
									yield put(
										showNotify({
											type: 'success',
											message: `Файл успешно загружен! Добавлено: ${added}, Обновлено: ${updated}`,
										})
									)
								}
							} catch (e) {
								console.error('Ошибка парсинга потока: ', e)
							}
						}
						yield put(setProgressPrecent(0))
						break
					}
				}
			}
		} while (retry)

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.error(error)
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
		yield put(showNotify({ type: 'error', message: 'Ошибка обработки файла, попробуйте позже.' }))
	}
}

function* downloadForm20({
	id,
	name,
	version,
	formYear,
}: {
	type: typeof UserProjectsType.DOWNLOAD_F20
	id: ReactText
	name: string
	version: string
	formYear?: ReactText
}) {
	let url = ''
	switch (version) {
		case 'base':
			url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${id}/f20`
			break
		case 'new':
			url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${id}/newf20`
			break
		case 'all':
			url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/forma20`
			break
		case 'allNewPlus':
			url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/forma20plus`
			break
		case 'newPlus':
			url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${id}/f20plus`
			break
		default:
			url = ''
	}

	const { userProjects } = store.getState().filter
	const { company } = store.getState().public
	const { sort, projectList } = store.getState().userProjects

	let ogrn: any = ''
	if (userProjects.showFilterState.companyId?.length === 1) {
		const companyId = userProjects.showFilterState.companyId[0]
		const currentOgrn = company.find(el => el.id == companyId)?.ogrn
		ogrn = currentOgrn ? `_${currentOgrn}` : ''
	}

	let params: Record<string, any> = {
		order: (sort ? '' : '-') + sort.sortName,
		limit: projectList.length,
		unc_sort: formYear || '',
	}

	const object = excludeData(userProjects.showFilterState)
	if (Object.keys(object).length > 0) {
		params = { ...params, ...object }
	}

	const paramsString = Object.entries(params)
		.filter(([_, value]) => value !== undefined)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string | number | boolean)}`)
		.join('&')

	const f20_filename = (ogrn: string) => {
		const d = new Date()
		return 'H' + (d.getMonth() + 1) + d.getDate() + ogrn + '_20_0_0'
	}

	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

	const avg_time_per_project = 0.05053915
	const expected_time = avg_time_per_project * Number(userProjects.countResult)
	const progressTask = yield fork(updateProgressDuringRequest, expected_time)

	let isAlreadyFetchingAccessToken = false
	let retry = false

	while (true) {
		try {
			const response: Response = yield call(() =>
				fetch(url + '?' + paramsString, {
					method: 'GET',
					headers: fetchHeaders(),
				})
			)

			if (response.status === 401) {
				if (!isAlreadyFetchingAccessToken) {
					isAlreadyFetchingAccessToken = true
					try {
						const refresh_token = localStorage.getItem('refresh_token') || ''
						if (!refresh_token) throw new Error('Refresh token is missing')

						const { access_token } = yield call(refreshToken, refresh_token)
						if (!access_token) throw new Error('Access token not returned')

						onAccessTokenFetched(access_token)
						retry = true
						continue
					} catch (authError) {
						console.error('Ошибка авторизации:', authError)
						yield put(
							showNotify({
								type: 'error',
								message: 'Ошибка авторизации. Попробуйте снова.',
							})
						)
						yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
						yield cancel(progressTask)
						yield put(setLoadingStates('', false))
						return
					} finally {
						isAlreadyFetchingAccessToken = false
					}
				}
			} else if (!response.ok) {
				throw new Error(`Ошибка при загрузке: ${response.statusText}`)
			}

			// Всё хорошо — обрабатываем файл
			const blob = yield call([response, 'blob'])
			const fileUrl = URL.createObjectURL(blob)
			const link = document.createElement('a')
			document.body.appendChild(link)
			link.href = fileUrl
			link.download = f20_filename(ogrn) + '.xlsx'
			link.click()
			link.remove()

			setProgressPrecent(100)
			break // выходим из цикла
		} catch (error) {
			console.error('Ошибка при загрузке формы 20:', error)
			break // или реализовать ограниченный retry
		}
	}

	yield cancel(progressTask)
	yield put(setProgressPrecent(100))
	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
	yield put(setLoadingStates('', false))
}

function* downloadForm20async() {
	const { userProjects } = store.getState().filter
	const { sort, projectList } = store.getState().userProjects

	let params = { order: (sort ? '' : '-') + sort.sortName, limit: projectList.length }
	const object = excludeData(userProjects.showFilterState)
	const intermediateValue = {
		...object,
	}
	if (userProjects.showFilterState || !!Object.keys(intermediateValue).length) {
		params = {
			...params,
			...intermediateValue,
		}
	}
	const paramsString = Object.entries(params)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&')

	// Асинхронная генерация и выгрузка файла

	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/forma20async`
	let taskId = null

	try {
		yield fetchWith401Retry(url + '?' + paramsString, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(response => response.json())
			.then(success => {
				taskId = success.queued.taskId
			})
			.catch(error => {
				store.dispatch(
					showNotify({
						type: 'error',
						message: 'Ошибка загрузки файла, попробуйте позже.',
					})
				)
			})
		yield put({ type: UserProjectsType.SET_F20_TASK, task: taskId })

		store.dispatch(
			showNotify({
				type: 'success',
				message: 'Форма 20 формируется. Ожидайте, загрузка начнется автоматически.',
			})
		)
	} catch (error) {
		console.log(error)
	}
}

function* downloadCheckWarns({
	sectionIdsArr,
}: {
	type: typeof UserProjectsType.DOWNLOAD_CHECK_WARNS
	sectionIdsArr: number[]
}) {
	const { userProjects } = store.getState().filter
	const { sort, projectList } = store.getState().userProjects

	let params: Record<string, any> = {
		order: (sort ? '' : '-') + sort.sortName,
		limit: projectList.length,
	}

	const object = excludeData(userProjects.showFilterState)
	if (Object.keys(object).length > 0) {
		params = { ...params, ...object }
	}

	const paramsString = Object.entries(params)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&')

	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/rule-error-many-xlsx?${paramsString}&with=messages`

	let isAlreadyFetchingAccessToken = false
	let retry = false

	try {
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

		const avg_time_per_project = 0.0430552
		const expected_time = avg_time_per_project * Number(userProjects.countResult)
		const progressTask = yield fork(updateProgressDuringRequest, expected_time)

		while (true) {
			try {
				const response: Response = yield call(() =>
					fetch(url, {
						method: 'POST',
						headers: fetchHeaders(),
						body: JSON.stringify({ sectionIds: sectionIdsArr }),
					})
				)

				if (response.status === 401) {
					if (!isAlreadyFetchingAccessToken) {
						isAlreadyFetchingAccessToken = true

						try {
							const refresh_token = localStorage.getItem('refresh_token') || ''
							if (!refresh_token) throw new Error('Refresh token not found')

							const { access_token } = yield call(refreshToken, refresh_token)
							if (!access_token) throw new Error('Access token not returned')

							onAccessTokenFetched(access_token)
							retry = true
							continue
						} catch (authError) {
							console.error('Ошибка авторизации:', authError)
							yield put(
								showNotify({
									type: 'error',
									message: 'Ошибка авторизации. Попробуйте снова.',
								})
							)
							yield cancel(progressTask)
							return
						} finally {
							isAlreadyFetchingAccessToken = false
						}
					}
				} else if (response.ok) {
					const blob = yield call([response, 'blob'])
					const downloadUrl = URL.createObjectURL(blob)
					const link = document.createElement('a')
					document.body.appendChild(link)
					link.href = downloadUrl
					link.download = `Проверка.xlsx`
					link.click()
					link.remove()

					yield cancel(progressTask)
					yield put(setProgressPrecent(100))
					break
				} else {
					throw new Error('Ошибка при скачивании файла')
				}
			} catch (fetchError) {
				console.error('Ошибка при запросе:', fetchError)
				yield put(
					showNotify({
						type: 'error',
						message: 'Произошла ошибка при скачивании отчёта.',
					})
				)
				yield cancel(progressTask)
				break
			}
		}
	} finally {
		yield put(setProgressPrecent(0))
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	}
}

function* checkF20link({ task }: { type: typeof UserProjectsType.CHECK_F20_LINK; task: ReactText }) {
	try {
		const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/fileExists?type=f20&name=${task}`

		let f20link = null

		yield fetchWith401Retry(url, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(response => response.json())
			.then(success => {
				f20link = success.done.fileUrl
			})
			.catch(error => {
				store.dispatch(
					showNotify({
						type: 'error',
						message: 'Ошибка запроса: ' + url,
					})
				)
			})

		if (f20link !== '') {
			yield put({ type: UserProjectsType.SET_F20_LINK, f20link: f20link })
			yield put({ type: UserProjectsType.SET_F20_TASK, task: null })
		}
	} catch (error) {
		console.log(error)
	}
}

function* uploadForm20({
	file,
	importInto,
	uncSort,
	companyId,
	url,
	version,
}: {
	type: typeof UserProjectsType.UPLOAD_F20
	file: any
	importInto: string
	uncSort: string
	companyId: string
	url: string
	version: string
}) {
	const fileTypes = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
	if (!fileTypes.includes(file[0].type)) {
		yield put(
			showNotify({
				type: 'warning',
				message: 'Неверный формат файла! Допустимый формат - *.xlsx',
			})
		)
		return
	}

	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

	const endpoint = version === 'import-form-new-20' ? 'uploadForm20plus' : 'uploadForm20'
	const requestUrl = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${endpoint}?importInto=${importInto}&uncSort=${uncSort}&companyId=${companyId}`

	const data = new FormData()
	data.append('file', file[0], file[0].name)

	let isAlreadyFetchingAccessToken = false
	let retry = false
	let attempts = 0
	const maxAttempts = 2

	try {
		do {
			if (attempts >= maxAttempts) {
				yield put(
					showNotify({
						type: 'error',
						message: 'Не удалось загрузить файл. Попробуйте позже.',
					})
				)
				break
			}
			attempts++

			const response: Response = yield call(() =>
				fetch(requestUrl, {
					method: 'POST',
					body: data,
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						Authorization: `Bearer ${localStorage.getItem('access_token')}`,
					},
				})
			)

			if (response.status === 401) {
				if (!isAlreadyFetchingAccessToken) {
					isAlreadyFetchingAccessToken = true

					try {
						const refresh_token = localStorage.getItem('refresh_token') || ''
						if (!refresh_token) throw new Error('Refresh token not found')

						const { access_token } = yield call(refreshToken, refresh_token)
						if (!access_token) throw new Error('Access token not returned')

						onAccessTokenFetched(access_token)
						retry = true
					} catch (authError) {
						console.error('Ошибка авторизации:', authError)
						yield put(
							showNotify({
								type: 'error',
								message: 'Ошибка авторизации. Попробуйте снова.',
							})
						)
						break
					} finally {
						isAlreadyFetchingAccessToken = false
					}

					continue
				}
			}

			if (!response.ok) {
				yield put(
					showNotify({
						type: 'error',
						message: 'Ошибка загрузки файла. Попробуйте позже.',
					})
				)
				break
			}

			retry = false

			// === JSON ответ (не поток) ===
			if (response.headers.get('content-type')?.includes('application/json')) {
				const success = yield response.json()

				if (success.status === 'failure') {
					yield put(showNotify({ type: 'error', message: success.message || 'Ошибка загрузки файла.' }))
				} else {
					const { errors, reportUrl } = success.done
					if (Array.isArray(errors?.Error) || Array.isArray(errors?.Notice)) {
						yield put(setDataImportMagazine(errors, reportUrl))
						if (errors?.Error?.length || errors?.Notice?.length) {
							yield put(setOpenModalImportMagazine(true))
						}
						yield put(
							showNotify({
								type: 'success',
								message:
									'Файл обработан!' +
									(errors?.Error?.length ? ` Количество ошибок: ${errors.Error.length}` : '') +
									(errors?.Notice?.length ? ` Количество предупреждений: ${errors.Notice.length}` : ''),
							})
						)
					}
				}
			}
			// === Потоковый ответ ===
			else {
				const reader = response.body?.getReader()
				if (!reader) throw new Error('Не удалось прочитать поток')

				const decoder = new TextDecoder('utf-8')
				let buffer = ''
				let finalJsonBuffer = ''

				while (true) {
					const { done, value } = yield reader.read()
					buffer += decoder.decode(value, { stream: true })

					let boundary = buffer.indexOf('\n')
					while (boundary !== -1) {
						const chunk = buffer.slice(0, boundary).trim()
						buffer = buffer.slice(boundary + 1)

						if (chunk.startsWith('data:')) {
							const percent = parseInt(chunk.replace('data:', '').trim())
							if (!isNaN(percent)) {
								yield put(setProgressPrecent(percent))
							}
						} else if (chunk) {
							finalJsonBuffer = chunk
						}
						boundary = buffer.indexOf('\n')
					}

					if (done) {
						if (buffer.trim()) {
							finalJsonBuffer = buffer.trim()
						}

						if (finalJsonBuffer) {
							try {
								const parsed = JSON.parse(finalJsonBuffer)
								const { errors, reportUrl } = parsed.done || {}

								if (parsed.status === 'failure') {
									yield put(showNotify({ type: 'error', message: parsed.message }))
								} else if (errors || reportUrl) {
									yield put(setDataImportMagazine(errors, reportUrl))
									if (errors?.Error?.length || errors?.Notice?.length) {
										yield put(setOpenModalImportMagazine(true))
									}
									yield put(
										showNotify({
											type: 'success',
											message:
												'Файл обработан!' +
												(errors?.Error?.length ? ` Количество ошибок: ${errors.Error.length}` : '') +
												(errors?.Notice?.length ? ` Количество предупреждений: ${errors.Notice.length}` : ''),
										})
									)
								}

								yield put(showFilterResult(url))
							} catch (e) {
								console.error('Ошибка парсинга потока:', e)
							}
						}

						yield put(setProgressPrecent(0))
						break
					}
				}
			}
		} while (retry)

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.error('Ошибка загрузки:', error)
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
		yield put(showNotify({ type: 'error', message: 'Ошибка обработки файла. Попробуйте позже.' }))
	}
}

function* downloadSvod({ id, name }: { type: typeof UserProjectsType.DOWNLOAD_SVOD; id: ReactText; name: string }) {
	// Сводный файл
	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/downloadSvod`
	const { userProjects } = store.getState().filter
	const { sort, projectList } = store.getState().userProjects

	let params = { order: (sort ? '' : '-') + sort.sortName, limit: projectList.length }
	const object = excludeData(userProjects.showFilterState)
	const intermediateValue = {
		...object,
	}
	if (userProjects.showFilterState || !!Object.keys(intermediateValue).length) {
		params = {
			...params,
			...intermediateValue,
		}
	}

	const paramsString = Object.entries(params)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&')

	try {
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

		yield fetchWith401Retry(url + '?' + paramsString, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = `Сводный.xlsx`
				link.click()
				link.remove()
			})

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.log(error)
	}
}
function* downloadUncRps({
	id,
	name,
}: {
	type: typeof UserProjectsType.DOWNLOAD_UNC_RPS
	id: ReactText
	name: string
}) {
	// Сводный файл
	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/exportRPSZip?ipr_id=${id}`
	const { userProjects } = store.getState().filter
	const { sort, projectList } = store.getState().userProjects

	let params = { order: (sort ? '' : '-') + sort.sortName, limit: projectList.length }
	const object = excludeData(userProjects.showFilterState)
	const intermediateValue = {
		...object,
	}
	if (userProjects.showFilterState || !!Object.keys(intermediateValue).length) {
		params = {
			...params,
			...intermediateValue,
		}
	}

	const paramsString = Object.entries(params)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&')

	try {
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

		yield fetchWith401Retry(url, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = `РПС на основании УНЦ.zip`
				link.click()
				link.remove()
			})

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.log(error)
	}
}

function* downloadArchiveTX({
	companyId,
	iprID,
}: {
	type: typeof UserProjectsType.DOWNLOAD_ARCHIVE_TX
	companyId: number
	iprID: number
}) {
	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/exportUserTechSolutionsAll`
	const { userProjects } = store.getState().filter
	const { sort, projectList } = store.getState().userProjects

	let params = { order: (sort ? '' : '-') + sort.sortName, limit: projectList.length }
	const object = excludeData(userProjects.showFilterState)
	const intermediateValue = {
		...object,
	}
	if (userProjects.showFilterState || !!Object.keys(intermediateValue).length) {
		params = {
			...params,
			...intermediateValue,
		}
	}

	const paramsString = Object.entries(params)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&')

	try {
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

		yield fetchWith401Retry(url + '?' + paramsString, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = `ФормаТХ.xlsx`
				link.click()
				link.remove()
			})

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.log(error)
	}
}

function* uploadSvod({ file }: { type: typeof UserProjectsType.UPLOAD_SVOD; file: any }) {
	try {
		const fileTypes = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
		if (!fileTypes.includes(file[0].type)) {
			yield put(
				showNotify({
					type: 'warning',
					message: 'Неверный формат файла! Допустимый формат - *.xlsx',
				})
			)
			return
		}
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

		const data = new FormData()
		data.append('file', file[0], file[0].name)

		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/uploadSvod`, {
			method: 'POST',
			body: data,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				Authorization: `Bearer ${localStorage.getItem('access_token')}`,
			},
		})
			.then(response => response.json())
			.then(success => {
				if (success.status === 'failure') {
					store.dispatch(
						showNotify({
							type: 'error',
							message: 'Ошибка загрузки файла, попробуйте позже.',
						})
					)
					store.dispatch(
						showNotify({
							type: 'error',
							message: success.message,
						})
					)
				} else {
					store.dispatch(
						showNotify({
							type: 'success',
							message:
								'Файл успешно загружен!' +
								' Обновлено проектов: ' +
								success.done.updated +
								' Перемещено в архив: ' +
								success.done.archived,
						})
					)
				}
			})
			.catch(() => {
				store.dispatch(
					showNotify({
						type: 'error',
						message: 'Ошибка загрузки файла, попробуйте позже.',
					})
				)
			})

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
	} catch (error) {
		console.log(error)
	}
}

function* copyProject({
	userProjectId,
	code,
	iprId,
	confirmed,
}: {
	type: typeof UserProjectsType.COPY_PROJECT
	userProjectId: ReactText
	code: ReactText
	iprId?: number | string
	confirmed?: number | string
}) {
	try {
		const options: any = {
			userProjectId,
			code,
		}
		if (iprId) {
			options.ipr_id = iprId
		}
		if (confirmed) {
			options.confirmed = confirmed
		}

		const project: IRequestProject = yield call(
			fetchData,
			`/user-projects`,
			(res: any) => res,
			'POST',
			JSON.stringify(options)
		)

		if (project.status === 'success') {
			if (!project.alert) {
				yield put(
					showNotify({
						type: 'success',
						message: `Создан новый проект ${project?.userProject?.code}`,
					})
				)
				yield put(setCopyAlert('success'))
			} else {
				yield put(setCopyAlert('alert'))
			}
		}
	} catch (error) {
		console.log(error)
	}
}
function* addVersionProject({
	data,
	versionName,
	uncSort,
	currentUrl,
	iprId,
}: {
	type: typeof UserProjectsType.ADD_NEW_VERSION
	data: IUserProject
	versionName: string
	currentUrl: string
	uncSort?: string
	iprId?: number
}) {
	const copy: IUserProject = uncSort
		? Object.assign({}, data, { version: versionName, unc_sort: uncSort, __projectId: data.id, ipr_id: iprId })
		: Object.assign({}, data, { version: versionName })

	delete copy.sumUncCost
	delete copy.userId
	delete copy.id
	delete copy.sumUncCostWithNds
	delete copy.totalInvestmentUncOffer
	delete copy.t7Id
	delete copy.t7Version
	delete copy.versions
	delete copy.author

	try {
		const project: IRequestProject = yield call(
			fetchData,
			`/user-projects`,
			(res: any) => res,
			'POST',
			JSON.stringify(copy)
		)
		if (project.status === 'success' || project) {
			if (project.alert) {
				const alert = project.alert
				yield put(
					showNotify({
						type: alert.type,
						message: alert.message,
					})
				)
			} else {
				yield put(
					showNotify({
						type: 'success',
						message: `Создана версия расчета ${versionName.replace('2018', '2019')}`,
					})
				)
			}
			yield put(push(`/${currentUrl}/project/${project.userProject.id}/parameters`))
		}
	} catch (error) {
		console.log(error)
	}
}

//Сага для download шаблона ненормированных затрат
function* getTplUnnormalizedСosts({
	id,
}: {
	type: typeof UserProjectsType.GET_TEMPLATE_UNNORMOLIZED_COSTS
	id: ReactText
}) {
	try {
		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${id}/t7-tpl`, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = `Шаблон ненормируемых затрат.xlsx`
				link.click()
				link.remove()
			})
	} catch (error) {
		console.log(error)
	}
}

//Сага для download сформированного файла ненормированных затрат
function* getUnnormalizedСosts({ id }: { type: typeof UserProjectsType.GET_UNNORMOLIZED_COSTS; id: ReactText }) {
	try {
		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${id}/t7`, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(res => res.blob())
			.then(blob => {
				const url = URL.createObjectURL(blob),
					link = document.createElement('a')
				document.body.appendChild(link)
				link.href = url
				link.download = `Шаблон ненормируемых затрат.xlsx`
				link.click()
				link.remove()
			})
	} catch (error) {
		console.log(error)
	}
}

//Сага для upload заполненного шаблона ненормированных затрат
function* uploaderUnnormalizedСosts({
	file,
	id,
}: {
	type: typeof UserProjectsType.UPLOAD_UNNORMOLIZED_COSTS
	file: any
	id: ReactText
}) {
	try {
		const fileTypes = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
		if (!fileTypes.includes(file[0].type)) {
			yield put(
				showNotify({
					type: 'warning',
					message: 'Неверный формат файла! Допустимый формат - *.xlsx',
				})
			)
			return
		}

		const data = new FormData()
		data.append('file', file[0], file[0].name)

		yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${id}/t7`, {
			method: 'POST',
			body: data,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				Authorization: `Bearer ${localStorage.getItem('access_token')}`,
			},
		})
			.then(response => response.json())
			.then(success => {
				if (success.status === 'failure') {
					store.dispatch(
						showNotify({
							type: 'error',
							message: 'Ошибка загрузки файла, попробуйте позже.',
						})
					)
				} else {
					store.dispatch(
						showNotify({
							type: 'success',
							message: 'Файл успешно загружен!',
						})
					)
				}
			})
			.catch(() => {
				store.dispatch(
					showNotify({
						type: 'error',
						message: 'Ошибка загрузки файла, попробуйте позже.',
					})
				)
			})
		yield put({ type: 'FETCH_USER_PROJECT', id: id })
		yield put({ type: 'GET_T7_DATA', id: id })
	} catch (error) {
		console.log(error)
	}
}

//Сага загрузки таблицы T7 проекта
function* getT7Data({ id, version }: { type: typeof UserProjectsType.GET_T7_DATA; id: string; version: number }) {
	try {
		yield put(loadingT7Data(true))

		if (version == null) version = 2

		const t7Data: IT7Data = yield call(
			fetchData,
			`/user-projects/${id}/T7Data?version=${version}`,
			(res: any) => res.t7
		)
		if (t7Data) {
			yield put({ type: 'SET_T7_DATA', t7Data })
			yield put(loadingT7Data(false))
		} else {
			yield put(loadingT7Data(false))
		}
	} catch (error) {
		yield put(loadingT7Data(false))
		console.log(error)
	}
}

//Сага сохранения таблицы ненормируемых расходов
function* saveT7Data({
	t7Data,
	userProjectId,
	version,
}: {
	type: typeof UserProjectsType.SAVE_T7_DATA
	t7Data: IT7Data
	userProjectId: ReactText
	version: number
}) {
	try {
		const project = yield call(
			fetchData,
			`/user-projects/${userProjectId}/updateT7?version=${version}`,
			(res: any) => res,
			'PATCH',
			JSON.stringify(t7Data)
		)

		const message =
			version == 1
				? `. Если ненормируемые затраты ранее заполнены по вкладке 20.2 формы 20, то они остаются приоритетными`
				: ``

		if (project) {
			yield put(
				showNotify({
					type: 'success',
					message: `Таблица ненормированных затрат обновлена` + message,
				})
			)
			yield put({ type: 'FETCH_USER_PROJECT', id: userProjectId })
		}
	} catch (error) {
		console.log(error)
	}
}

//Сага удаления файла ненормированных затрат
function* deleteUnnormalizedСosts({ id }: { type: typeof UserProjectsType.DELETE_UNNORMOLIZED_COSTS; id: ReactText }) {
	try {
		const res: IRequestProject = yield call(fetchData, `/user-projects/${id}/t7`, (res: any) => res, 'DELETE')

		if (res.status === 'success') {
			yield put(
				showNotify({
					type: 'success',
					message: 'Файл успешно удален!',
				})
			)
		}
	} catch (error) {
		console.log(error)
	}
}

function* updateCalc(data: any) {
	let isAlreadyFetchingAccessToken = false
	let retry = false
	let attempts = 0
	const maxAttempts = 2

	const query = data.params
	const limit = data.limit ?? 10000

	let params = {
		order: (query.order ? '' : '-') + query.sortName,
		limit,
	}

	const { userProjects } = store.getState().filter
	const object = excludeData(userProjects.showFilterState)
	const intermediateValue = { ...object }

	if (userProjects.showFilterState || Object.keys(intermediateValue).length > 0) {
		params = { ...params, ...intermediateValue }
	}

	const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/computeAll?${QueryString.stringify(params, {
		arrayFormat: 'comma',
	})}`

	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

	do {
		try {
			if (attempts >= maxAttempts) {
				yield put(
					showNotify({
						type: 'error',
						message: 'Не удалось завершить вычисления. Попробуйте позже.',
					})
				)
				break
			}

			attempts++

			const response: Response = yield call(fetch, url, {
				method: 'POST',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/json',
					Authorization: `Bearer ${localStorage.getItem('access_token')}`,
				},
			})

			if (response.status === 401 && !isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true

				try {
					const refresh_token = localStorage.getItem('refresh_token') || ''
					if (!refresh_token) throw new Error('Refresh token is missing')

					const { access_token } = yield call(refreshToken, refresh_token)
					if (!access_token) throw new Error('Access token not returned')

					onAccessTokenFetched(access_token)
					retry = true // повторим запрос
				} catch (authError) {
					console.error('Ошибка авторизации:', authError)
					yield put(
						showNotify({
							type: 'error',
							message: 'Ошибка авторизации. Попробуйте снова.',
						})
					)
					break
				} finally {
					isAlreadyFetchingAccessToken = false
				}
				continue
			}

			if (!response.ok) {
				yield put(
					showNotify({
						type: 'error',
						message: 'Ошибка при вычислении, попробуйте позже.',
					})
				)
				break
			}

			if (!response.body) {
				yield put(
					showNotify({
						type: 'error',
						message: 'Ошибка: тело ответа от сервера не получено.',
					})
				)
				break
			}

			retry = false

			// Стриминг данных
			const reader = response.body.getReader()
			const decoder = new TextDecoder('utf-8')
			let buffer = ''
			let finalJsonBuffer = ''

			while (true) {
				const { done, value } = yield call([reader, reader.read])
				if (done) break

				buffer += decoder.decode(value, { stream: true })

				let boundary = buffer.indexOf('\n')
				while (boundary !== -1) {
					const chunk = buffer.slice(0, boundary).trim()
					buffer = buffer.slice(boundary + 1)

					if (chunk.startsWith('data:')) {
						const progressPercent = parseInt(chunk.replace('data:', '').trim())
						if (!isNaN(progressPercent)) {
							yield put(setProgressPrecent(progressPercent))
						}
					} else if (chunk) {
						finalJsonBuffer = chunk
					}

					boundary = buffer.indexOf('\n')
				}
			}

			if (buffer.trim()) {
				finalJsonBuffer = buffer.trim()
			}

			if (finalJsonBuffer) {
				try {
					const parsedData = JSON.parse(finalJsonBuffer)

					if (parsedData.status === 'success') {
						yield put(
							showNotify({
								type: 'success',
								message: 'Отобранные проекты успешно обновлены!',
							})
						)
					} else {
						yield put(
							showNotify({
								type: 'error',
								message: `Ошибка: ${parsedData.message}`,
							})
						)
					}
				} catch (e) {
					console.error('Ошибка парсинга JSON: ', e)
					yield put(
						showNotify({
							type: 'error',
							message: 'Ошибка обработки данных, попробуйте позже.',
						})
					)
				}
			}

			break
		} catch (error) {
			console.error('Произошла ошибка: ', error)
			yield put(
				showNotify({
					type: 'error',
					message: 'Произошла ошибка при обработке запроса, попробуйте позже.',
				})
			)
			break
		}
	} while (retry)

	yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
	yield put(setProgressPrecent(0))
	yield put(setLoadingStates('', false))
}

function* sortUserProjects({
	order,
	sortName,
}: {
	type: typeof UserProjectsType.SORT_USER_PROJECTS
	sortName: string
	order: boolean
	archive: any
}) {
	try {
		yield put(loadingUserProjects(true))
		yield put(setUserProjects([], 0, 0, 0, 0))
		let params = { order: (order ? '' : '-') + sortName, limit: limit }

		const { userProjects } = store.getState().filter
		const object = excludeData(userProjects.showFilterState)

		const intermediateValue = {
			...object,
		}

		if (userProjects.showFilterState || !!Object.keys(intermediateValue).length) {
			params = {
				...params,
				...intermediateValue,
			}
		}

		const res = yield call(userProjectsApi, params)

		if (res.userProjects.length < res.userProjectsCnt) {
			yield put(setAllowMoreUserProjects(true))
		}

		if (res && res.status === 'success') {
			yield put({
				type: 'SET_USER_PROJECTS',
				projects: res.userProjects.length ? res.userProjects : [],
				userProjectsCnt: res.userProjectsCnt ? res.userProjectsCnt : 0,
				totalInvestmentUncOfferSum: Number(res.totalInvestmentUncOfferSum),
				userProjects18Cnt: res.userProjects18Cnt ? res.userProjects18Cnt : 0,
				userProjects24Cnt: res.userProjects24Cnt ? res.userProjects24Cnt : 0,
			})
			yield put(setExportable(res.exportable))
		}
	} catch (error) {
		console.log(error)
	} finally {
		yield put(loadingUserProjects(false))
	}
}

function* appendUserProjects({
	projectsCount,
}: {
	type: typeof UserProjectsType.APPEND_USER_PROJECTS
	projectsCount: number
}): Generator<any, void, any> {
	try {
		yield put(loadingUserProjects(true))
		const { sort, allowMoreUserProjects } = store.getState().userProjects

		if (!allowMoreUserProjects) return

		let params = { order: (sort.order ? '' : '-') + sort.sortName, limit: limit, offset: projectsCount * limit }

		const { userProjects } = store.getState().filter
		const object = excludeData(userProjects.showFilterState)

		const intermediateValue = {
			...object,
		}

		if (userProjects.showFilterState) {
			params = {
				...params,
				...intermediateValue,
			}
		}

		const res = yield call(userProjectsApi, params)

		if (res && res.status === 'success') {
			const projects = res.userProjects
			const total = res.userProjectsCnt || 0
			const currentTotalCount = projectsCount * limit + projects.length

			if (res.userProjects.length) {
				yield put(addUserProjects(projects))
				yield put(setUserProjectsPaginationCount(projectsCount))
			} else {
				yield put(setAllowMoreUserProjects(false))
			}

			if (!(res.userProjects.length || res.userProjects.length > limit) || currentTotalCount >= total) {
				yield put(setAllowMoreUserProjects(false))
				yield put(setUserProjectsPaginationCount(0))
			}
		}
	} catch (error) {
		console.log(error)
	} finally {
		yield put(loadingUserProjects(false))
	}
}

function* fetchInvestGroups() {
	try {
		const investGroups: any[] = yield call(fetchData, `/invest-group`, (res: any) => res.invest_group)
		if (investGroups) {
			yield put({ type: 'SET_INVEST_GROUP', investGroups: investGroups })
		}
	} catch (error) {
		console.log(error)
	}
}

function* getProjectTechSolutions({
	projectId,
	params,
}: {
	type: typeof UserProjectsType.GET_PROJECT_TECH_SOLUTIONS
	projectId: number | string
	params?: { page?: number; order?: string }
}) {
	try {
		const page = params?.page ?? 0
		const offset = page * 10
		const order = params?.order ?? ''

		yield put(setLoadProjectSolutions(true)) // Всегда при пагинации

		const queryParams = new URLSearchParams({
			// limit: '50',
			// offset: "0",
		})
		// queryParams.set('offset', offset.toString())
		// queryParams.set('limit', '10')

		if (order) queryParams.set('order', order)

		const url = `/ptk/v2/user-projects/${projectId}/user-techSolutions?${queryParams}`

		const res: any = yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}${url}`, {
			method: 'GET',
			headers: fetchHeaders(),
		})
			.then(response => response.json())
			.then(success => {
				if (success.status === 'success') {
					return success
				}
			})
		const techSolutions = res.userTechSolutions || []
		const resultsCnt = res.resultsCnt || 0

		yield put(setProjectTechSolutions(techSolutions, resultsCnt, order, page))
	} catch (error) {
		console.log(error)
	} finally {
		yield put(setLoadProjectSolutions(false))
	}
}

function* changeTechCount({
	techId,
	count,
}: {
	type: typeof UserProjectsType.CHANGE_PROJECT_TECH_COUNT
	techId: number | string
	count: number
}) {
	try {
		const res: any = yield fetchWith401Retry(
			`https://${process.env.REACT_APP_ENV}/ptk/v2/user-tech-solutions/${techId}
`,
			{
				method: 'PATCH',
				headers: fetchHeaders(),
				body: JSON.stringify({ count }),
			}
		)
			.then(response => response.json())
			.then(success => {
				if (success.status === 'success') {
					return success
				}
			})
	} catch (error) {
		console.log(error)
	}
}

function* changeTech({ solution }: { type: typeof UserProjectsType.CHANGE_PROJECT_TECH; solution: any }) {
	const { id, ...solutionDataWithoutId } = solution
	try {
		const res: any = yield fetchWith401Retry(
			`https://${process.env.REACT_APP_ENV}/ptk/v2/user-tech-solutions/${id}
			
`,
			{
				method: 'PATCH',
				headers: fetchHeaders(),
				body: JSON.stringify(solutionDataWithoutId),
			}
		)
			.then(response => response.json())
			.then(success => {
				if (success.status === 'success') {
					return success
				}
			})
	} catch (error) {
		console.log(error)
	}
}
function* deleteProjectTechSolution({
	techId,
	projectId,
}: {
	type: typeof UserProjectsType.DELETE_PROJECT_TECH_SOLUTION
	techId: number | string
	projectId: number | string
}) {
	try {
		const res: any = yield fetchWith401Retry(
			`https://${process.env.REACT_APP_ENV}/ptk/v2/user-tech-solutions/${techId}
`,
			{
				method: 'DELETE',
				headers: fetchHeaders(),
			}
		)
			.then(response => response.json())
			.then(success => {
				if (success.status === 'success') {
					return 'success'
				}
			})
		if (res == 'success') {
			yield put({ type: 'GET_PROJECT_TECH_SOLUTIONS', projectId: projectId })
			yield put(
				showNotify({
					type: 'success',
					message: `Запись удалена`,
				})
			)
		}
	} catch (error) {
		console.log(error)
	}
}

function* createTechSolution({ solution }: { type: typeof UserProjectsType.CREATE_TECH_SOLUTION; solution: any }) {
	try {
		const { userProjectId, comnapyId, regionId, regionZoneId, uncTechSolutionId, count } = solution

		const body = {
			userProjectId,
			uncTechSolutionId,
			count,
			regionId,
			regionZoneId,
		}
		const url = `/ptk/v2/user-tech-solutions`

		const res: any = yield fetchWith401Retry(`https://${process.env.REACT_APP_ENV}${url}`, {
			method: 'POST',
			headers: fetchHeaders(),
			body: JSON.stringify(body),
		})
			.then(res => res.json())
			.then(success => {
				if (success.status === 'success') {
					return success
				}
			})

		if (res.status === 'success') {
			yield put({ type: 'GET_PROJECT_TECH_SOLUTIONS', projectId: userProjectId })
			yield put({ type: 'FETCH_UNCS', id: userProjectId })
			yield put(
				showNotify({
					type: 'success',
					message: `Добавлено новое тех. решение: ${solution.techParamName}`,
				})
			)
		}
	} catch (error) {
		console.error(error)
		yield put(
			showNotify({
				type: 'error',
				message: `Ошибка при создании тех. решения: ${error}`,
			})
		)
	} finally {
		// yield put(setCreateLoad(false))
	}
}

function* downloadTechSolutions({
	projectId,
}: {
	type: typeof UserProjectsType.DOWNLOAD_SOLUTIONS_PROJECT
	projectId: string
}) {
	try {
		const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${projectId}/exportUserTechSolutions`

		// // Запускаем прогресс-бар загрузки
		// const avg_time_per_request = 0.05
		// const progressTask = yield fork(updateProgressDuringRequest, avg_time_per_request * 100)

		const response = yield call(() =>
			fetchWith401Retry(url, { method: 'GET', headers: fetchHeaders() })
				.then(res => res.blob())
				.then(blob => {
					const url = URL.createObjectURL(blob)
					const link = document.createElement('a')
					document.body.appendChild(link)
					link.href = url
					link.download = `Тех_решения_${new Date().toISOString().slice(0, 10)}.xlsx`
					link.click()
					link.remove()
				})
		)

		// Завершаем прогресс-бар
		// yield cancel(progressTask)
		// yield put(setProgressPrecent(100))
	} catch (error) {
		console.error('Ошибка при скачивании тех. решений:', error)
	} finally {
		// yield put(setProgressPrecent(0))
		// yield put(setLoadingStates('', false))
	}
}

function* importTechSolutionsProject({
	file,
	projectId,
}: {
	type: typeof UserProjectsType.UPLOAD_SOLUTIONS_PROJECT
	file: File
	projectId: number
}) {
	const fileTypes = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
	try {
		if (!fileTypes.includes(file.type)) {
			yield put(showNotify({ type: 'warning', message: 'Неверный формат файла! Допустимый формат - *.xlsx' }))
			return
		}

		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: true })

		const formData = new FormData()
		formData.append('form-data', file, file.name)

		let attempts = 0
		const maxAttempts = 2
		let retry = false

		do {
			if (attempts > maxAttempts) {
				yield put(showNotify({ type: 'error', message: 'Не удалось загрузить файл.' }))
				return
			}
			attempts++

			const accessToken = localStorage.getItem('access_token')
			const response: Response = yield call(
				fetch,
				`https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${projectId}/importUserTechSolutions`,
				{
					method: 'POST',
					body: formData,
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						Authorization: `Bearer ${accessToken}`,
					},
				}
			)

			// Если access_token истёк — обновляем
			if (response.status === 401) {
				try {
					const refresh_token = localStorage.getItem('refresh_token') || ''
					if (!refresh_token) throw new Error('Refresh token is missing')

					const { access_token } = yield call(refreshToken, refresh_token)
					if (!access_token) throw new Error('Access token not returned')

					onAccessTokenFetched(access_token)
					retry = true
					continue
				} catch (authError) {
					yield put(showNotify({ type: 'error', message: 'Ошибка авторизации. Попробуйте снова.' }))
					return
				}
			}

			const result = yield call([response, 'json'])

			if (response.ok && result.status === 'success') {
				const { added, errors } = result.done || {}

				yield put(showNotify({ type: 'success', message: `Импорт успешно завершён` }))

				if (errors?.length) {
					yield put(showNotify({ type: 'error', message: errors.join(', ') }))
				}
			} else {
				yield put(showNotify({ type: 'error', message: 'Ошибка при импорте файла.' }))
			}

			retry = false
		} while (retry)
	} catch (error) {
		console.error('Ошибка в импорте:', error)
		yield put(showNotify({ type: 'error', message: 'Ошибка обработки файла. Попробуйте позже.' }))
	} finally {
		yield put({ type: UserProjectsType.SHOW_LOADER, showLoader: false })
		yield put(setLoadingStates('', false))
		yield put({ type: 'FETCH_USER_PROJECT', id: projectId })
		yield put({ type: 'FETCH_UNCS', id: projectId })
		yield put({ type: 'GET_PROJECT_TECH_SOLUTIONS', projectId: projectId })
	}
}

function* getProjectRpc({
  params
}: {
  type: UserProjectsType.GET_PROJECT_RPC,
  params: any
}) {
  try {

    const url = `/user-projects/${params.projectId}/analog-objects`

    yield put(setProjectRPC({ isObjectsAnalogLoading: true }));

    const response: any = yield call(fetchData, url, (res: any) => res);

    if(response?.user_analog_objects ) {
      const res: any = [];
      
      if(response?.user_analog_objects?.length) {
        response.user_analog_objects.forEach((obj1: any) => {
          if(obj1?.analog_object) res.push({ 
            ...obj1.analog_object,
            idConnectProjectAndOA: obj1?.id ?? null,
            count: obj1?.count,
            id: obj1?.id,
            // @ts-ignore
            comment: obj1?.comment
          });
        })
      }

      yield put(
        setProjectRPC({
          isObjectsAnalogLoading: false,
          objectsAnalog: res,
        })
      )
    }

    yield put(setProjectRPC({ isObjectsAnalogLoading: false }));
    
  } catch (error) {
    console.error('Ошибка при загрузке:', error)

    yield put(
      showNotify({
        type: 'error',
        message: `Ошибка при загрузке: ${error}`,
      })
    )
  }
}

function* getProjectRpcExport({
  params
}: {
  type: UserProjectsType.GET_PROJECT_RPC_EXPORT,
  params: any
}) {
  try {

    yield put(setProjectRPC({ isObjectsAnalogExporting: true }));

    const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${params.projectId}/analog-objects/export`

    const response = yield call(() =>
      fetchWith401Retry(url, { method: 'GET', headers: fetchHeaders() })
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          document.body.appendChild(link)
          link.href = url
          link.download = `Объекты_аналоги_${new Date().toISOString().slice(0, 10)}.xlsx`
          link.click()
          link.remove()
        })
    )

    yield put(setProjectRPC({ isObjectsAnalogExporting: false }));

  } catch (error) {
    console.error('Ошибка при загрузке:', error)

    yield put(
      showNotify({
        type: 'error',
        message: `Ошибка при загрузке: ${error}`,
      })
    )
  }
}

function* postProjectObjectsAnalog({
  params
}: {
  type: UserProjectsType.POST_PROJECT_RPC,
  params: any
}) {
  try {

    let statusResponse: any = null;
    const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/user-projects/${params.projectId}/analog-objects`
    
    yield put(setProjectAddModalOA({ isAdding: true }));

    const response: Response = yield call(() =>
      fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          analog_object_id: params.oaId,
          count: 0
        }),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json'
        },
      }).then(res => {
        statusResponse = res?.status;

        return res.json();
      })
    )

    // @ts-ignore
    if(response.status === 'success' && response?.user_analog_objects?.analog_object) {
      
      yield put(updateProjectRPC({
        actionType: 'push',
        
        data: {
          // @ts-ignore
          ...response.user_analog_objects?.analog_object,
          // @ts-ignore
          idConnectProjectAndOA: response.user_analog_objects?.id,
          // @ts-ignore
          count: response.user_analog_objects?.count,
          // @ts-ignore
          id: response.user_analog_objects?.id,
          // @ts-ignore
          comment: response.user_analog_objects?.comment
        }
      }));

      yield put(setProjectAddModalOA(null));

      yield put(
        showNotify({
          type: 'success',
          message: 'Объект-аналог успешно добавлен',
        })
      );
    }
    
    if(statusResponse && statusResponse !== 201) {
      let errorsStr = '';
      
      // @ts-ignore
      if(response?.errors) {
        // @ts-ignore
        Object.values(response.errors).forEach((error: []) => {
          if(error?.length) {
            error.forEach((er) => {
              errorsStr += `${er}`;
            });
          }
        });
      }
      
      // @ts-ignore
      if(!response?.errors && response?.message) {
        // @ts-ignore
        errorsStr = response.message;
      }
      
      yield put(setProjectAddModalOA({ isAdding: false }));
      
      yield put(
        showNotify({
          type: 'error',
          message: `Не удалось добавить объект-аналог. Ошибка: ${errorsStr}`,
        })
      );
    }

  } catch (error) {
    console.error('Ошибка при создании объекта:', error)

    yield put(
      showNotify({
        type: 'error',
        message: `Ошибка при создании объекта:${error}`,
      })
    )
  }
}

function* deleteProjectObjectsAnalog({
  params
}: {
  type: UserProjectsType.DELETE_PROJECT_RPC,
  params: any
}) {
  try {

    const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/analog-objects/${params.idObjectAnalog}`

    yield put(setProjectDeleteModalOA({ isDeleting: true }));

    const response: Response = yield call(() =>
      fetch(url, {
        method: 'DELETE',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      }).then(res => {
        return res.json();
      })
    )

    // @ts-ignore
    if(response.status === 'success') {

      yield put(setDeletedProjectRPC({
        idObjectAnalog: params.idObjectAnalog,
        status: response.status
      }));

      yield put(setProjectDeleteModalOA(null));

      yield put(
        showNotify({
          type: 'success',
          message: `Объект-аналог успешно удален`,
        })
      );
    }

  } catch (error) {
    console.error('Ошибка при удалении объекта:', error)

    yield put(
      showNotify({
        type: 'error',
        message: `Ошибка при удалении объекта:${error}`,
      })
    )
  } finally {
    yield put(setProjectDeleteModalOA(null));
  }
}

function* patchProjectObjectAnalog({
  params
}: {
  type: UserProjectsType.PATCH_PROJECT_OA,
  params: any
}) {
  try {

    let statusResponse: any = null;
    const url = `https://${process.env.REACT_APP_ENV}/ptk/v2/analog-objects/${params.idConnectProjectAndOA}`;

    yield put(setProjectAddModalOA({ isAdding: true }));

    const response: Response = yield call(() =>
      fetch(url, {
        method: 'PATCH',
        body: JSON.stringify({
          comment: params?.comment ?? '',
          count: params?.count ?? 0,
        }),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json'
        },
      }).then(res => {
        statusResponse = res?.status;

        return res.json();
      })
    )

    // @ts-ignore
    if(response?.status === 'success') {

      yield put(setProjectAddModalOA(null));

      yield put(
        showNotify({
          type: 'success',
          message: 'Данные успешно обновлены',
        })
      );
    }

    if(statusResponse && statusResponse !== 200) {
      let errorsStr = '';

      // @ts-ignore
      if(response?.errors) {
        // @ts-ignore
        Object.values(response.errors).forEach((error: []) => {
          if(error?.length) {
            error.forEach((er) => {
              errorsStr += `${er}`;
            });
          }
        });
      }

      // @ts-ignore
      if(!response?.errors && response?.message) {
        // @ts-ignore
        errorsStr = response.message;
      }

      yield put(setProjectAddModalOA({ isAdding: false }));

      yield put(
        showNotify({
          type: 'error',
          message: `Не удалось обновить объект-аналог. Ошибка: ${errorsStr}`,
        })
      );
    }

  } catch (error) {
    console.error('Ошибка при обновлении объекта:', error)

    yield put(
      showNotify({
        type: 'error',
        message: `Ошибка при обновлении объекта: ${error}`,
      })
    )
  }
}

export default function* watchUserProject() {
	yield takeEvery(UserProjectsType.DELETE_UNNORMOLIZED_COSTS, deleteUnnormalizedСosts)
	yield takeEvery(UserProjectsType.UPLOAD_UNNORMOLIZED_COSTS, uploaderUnnormalizedСosts)
	yield takeEvery(UserProjectsType.APPEND_USER_PROJECTS, appendUserProjects)
	yield takeEvery(UserProjectsType.GET_UNNORMOLIZED_COSTS, getUnnormalizedСosts)
	yield takeEvery(UserProjectsType.SORT_USER_PROJECTS, sortUserProjects)
	yield takeEvery(UserProjectsType.COPY_PROJECT, copyProject)
	yield takeEvery(UserProjectsType.ADD_NEW_VERSION, addVersionProject)
	yield takeEvery(UserProjectsType.GET_TEMPLATE_UNNORMOLIZED_COSTS, getTplUnnormalizedСosts)
	yield takeEvery(UserProjectsType.DOWNLOAD_F20, downloadForm20)
	yield takeEvery(UserProjectsType.DOWNLOAD_F20_ASYNC, downloadForm20async)
	yield takeEvery(UserProjectsType.DOWNLOAD_CHECK_WARNS, downloadCheckWarns)
	yield takeEvery(UserProjectsType.CHECK_F20_LINK, checkF20link)
	yield takeEvery(UserProjectsType.MASS_CHECK, massCheck)
	yield takeEvery(UserProjectsType.UPLOAD_F20, uploadForm20)
	yield takeEvery(UserProjectsType.DOWNLOAD_F2, downloadForm2)
	yield takeEvery(UserProjectsType.UPLOAD_F2, uploadForm2)
	yield takeEvery(UserProjectsType.DOWNLOAD_SVOD, downloadSvod)
	yield takeEvery(UserProjectsType.DOWNLOAD_UNC_RPS, downloadUncRps)

	yield takeEvery(UserProjectsType.DOWNLOAD_ARCHIVE_TX, downloadArchiveTX)
	yield takeEvery(UserProjectsType.UPLOAD_SVOD, uploadSvod)
	yield takeEvery(UserProjectsType.UPLOADER_RULES_CHECK, uploaderRulesCheck)
	yield takeEvery(UserProjectsType.DOWNLOAD_RULES_CHECK, downloadRulesCheck)
	yield takeEvery(UserProjectsType.SET_DOWNLOAD_IMPORT_DATA, downloadImportLog)
	yield takeEvery(UserProjectsType.GET_CHECKED_ERRORS, getCheckedErrors)
	yield takeEvery(UserProjectsType.AUTO_ADD_UNC, autoAddUnc)
	yield takeLatest(UserProjectsType.UPDATE_DEFLATORS, updateDeflators)
	yield takeLatest(UserProjectsType.UPDATE_DEFLATORS_VALUE, updateDeflatorsValue)
	yield takeLatest(UserProjectsType.GET_DEFLATORS, getAllDeflators)
	yield takeEvery(UserProjectsType.SELECT_VOLTAGE, selectVoltage)
	yield takeEvery(UserProjectsType.GET_UNC_CELLS, handleUncCells)
	yield takeEvery(UserProjectsType.CHANGE_UNC_VOLTAGE, changeUncVoltage)
	yield takeEvery(UserProjectsType.CHANGE_UNC_REGION, changeUncRegion)
	yield takeEvery(UserProjectsType.CHANGE_UNC_COUNTER, changeUncCounter)
	yield takeEvery(UserProjectsType.CHANGE_UNC_COMMENT, changeUncComment)
	yield takeEvery(UserProjectsType.CHANGE_UNC_CF_ARCHITECTURE, changeUncCfArchitecture)
	yield takeLatest(UserProjectsType.FETCH_UNC_TABLE_DATA, fetchUncTableData)
	yield takeLatest(UserProjectsType.FETCH_UNCS, fetchUncs)
	yield takeLatest(UserProjectsType.GET_NON_STANDARDIZED_COSTS, fetchNonStandardizedCosts)
	yield takeLatest(UserProjectsType.GET_T7_DATA, getT7Data)
	// yield takeLatest(UserProjectsType.GET_USER_PROJECTS, getMyProjects)
	// 	yield takeEvery(UserProjectsType.APPEND_UNC_SEARCH, appendPricesSearch)
	// 	yield takeLatest(UserProjectsType.FETCH_MINI_TABLE, fetchMiniTable)
	// yield takeLatest(UserProjectsType.FETCH_COST_TABLE, fetchCostTable)
	yield takeLatest(UserProjectsType.CHANGE_FORM_TWENTY_NAME, changeFormTwentyName)
	yield takeLatest(UserProjectsType.CHANGE_REGION_FACTOR, changeRegionFactor)
	yield takeEvery(UserProjectsType.DELETE_UNC, deleteUnc)
	yield takeEvery(UserProjectsType.GET_ANALOG_UNC, genAnalogUnc)
	yield takeEvery(UserProjectsType.DOWNLOAD_TEMPLATE, downloadTemplate)
	yield takeEvery(UserProjectsType.IMPORT_TECH_SOLUTIONS, importTechSolutions)
	yield takeEvery(UserProjectsType.UPLOAD_SOLUTIONS_PROJECT, importTechSolutionsProject)

	yield takeEvery(UserProjectsType.UPDATE_ASSIST_STATUS, changeAssistStatus)
	yield takeEvery(UserProjectsType.GET_ASSIST_STATUS, fetchAssistStatus)
	// yield takeEvery(UserProjectsType.GET_PROGRESS_UPDATE, handleSSERequest)

	yield takeEvery(UserProjectsType.ADD_UNC, addUnc)
	// yield takeLatest(UserProjectsType.FETCH_MINI_TABLE, fetchMiniTable)
	yield takeEvery(UserProjectsType.CREATE_SPECIAL_UNC, createSpecialUnc)
	yield takeEvery(UserProjectsType.CREATE_UNCS_B1, createUncsB1)
	yield takeEvery(UserProjectsType.CREATE_UNC_B1, createUncB1)
	yield takeLatest(UserProjectsType.REPLACE_UNC, replaceUnc)
	yield takeLatest(UserProjectsType.UNC_POSITION_EDIT, uncEdit)
	yield takeLatest(UserProjectsType.SAVE_USER_PROJECT, saveUserProject)
	yield takeLatest(UserProjectsType.UPDATE_STATUS_USER_PROJECT, updateStatusUserProject)
	yield takeLatest(UserProjectsType.FETCH_USER_PROJECT, fetchUserProject)
	yield takeLatest(UserProjectsType.DELETE_USER_PROJECT, deleteUserProject)
	yield takeLatest(UserProjectsType.SAVE_T7_DATA, saveT7Data)
	yield takeEvery(UserProjectsType.CREATE_TECH_SOLUTION, createTechSolution)
	yield takeLatest(UserProjectsType.UPDATE_CALC, updateCalc)
	yield takeEvery(UserProjectsType.GET_INVEST_GROUP, fetchInvestGroups)
	yield takeEvery(UserProjectsType.GET_PROJECT_TECH_SOLUTIONS, getProjectTechSolutions)
	yield takeEvery(UserProjectsType.CHANGE_PROJECT_TECH_COUNT, changeTechCount)
	yield takeEvery(UserProjectsType.CHANGE_PROJECT_TECH, changeTech)
	yield takeEvery(UserProjectsType.DELETE_PROJECT_TECH_SOLUTION, deleteProjectTechSolution)
	yield takeLatest(UserProjectsType.DOWNLOAD_SOLUTIONS_PROJECT, downloadTechSolutions)
	
  yield takeLatest(UserProjectsType.GET_PROJECT_RPC, getProjectRpc)
  yield takeLatest(UserProjectsType.GET_PROJECT_RPC_EXPORT, getProjectRpcExport)
  yield takeLatest(UserProjectsType.POST_PROJECT_RPC, postProjectObjectsAnalog)
  yield takeLatest(UserProjectsType.DELETE_PROJECT_RPC, deleteProjectObjectsAnalog)
  yield debounce(500, UserProjectsType.PATCH_PROJECT_OA, patchProjectObjectAnalog)
}
